// This file is auto-generated by @hey-api/openapi-ts

export const $AIRLocationResult = {
  properties: {
    location_id: {
      type: "string",
      title: "Location Id",
      default: "",
    },
    location_number: {
      type: "string",
      title: "Location Number",
      default: "",
    },
    location_name: {
      type: "string",
      title: "Location Name",
      default: "",
    },
    street_address: {
      type: "string",
      title: "Street Address",
      default: "",
    },
    city: {
      type: "string",
      title: "City",
      default: "",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    aal_rl_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Rl By Peril",
      default: {},
    },
    location_detail: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationDetail",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["address_id"],
  title: "AIRLocationResult",
  description: `API type for AIR (ICM_YLT) per-location results.

ICM_YLT data is persisted in the identical \`\`RMSLocationResult\`\` JSONB
shape via the shared elt_persist pipeline, so this is structurally a copy.
It exists purely to give the AIR-backed \`\`air\`\` field a vendor-accurate
name in the public API / generated client, distinct from the RMS results.`,
} as const;

export const $AddCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["report_id", "message"],
  title: "AddCommentRequest",
} as const;

export const $AddCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "AddCommentResponse",
} as const;

export const $AddManualAddressRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address: {
      $ref: "#/components/schemas/RawAddress",
    },
  },
  type: "object",
  required: ["report_id", "address"],
  title: "AddManualAddressRequest",
} as const;

export const $AddManualAddressResponse = {
  properties: {
    report: {
      $ref: "#/components/schemas/ReportResponse",
    },
  },
  type: "object",
  required: ["report"],
  title: "AddManualAddressResponse",
} as const;

export const $AddSavedFilterRequest = {
  properties: {
    url: {
      type: "string",
      title: "Url",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
  },
  type: "object",
  required: ["url", "nickname", "is_default"],
  title: "AddSavedFilterRequest",
} as const;

export const $AdditionalAssigneeInfo = {
  properties: {
    assignees: {
      additionalProperties: {
        type: "string",
      },
      propertyNames: {
        const: "handler",
      },
      type: "object",
      title: "Assignees",
    },
  },
  type: "object",
  required: ["assignees"],
  title: "AdditionalAssigneeInfo",
} as const;

export const $Address = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    is_deleted: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Deleted",
    },
    default_sort_key: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Default Sort Key",
    },
    private_computed_values: {
      $ref: "#/components/schemas/RawAddress",
    },
    private_original_values: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Original Values",
    },
    private_overrides: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "number",
          },
          {
            type: "integer",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Overrides",
    },
    private_flags: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              type: "string",
              enum: [
                "missing_coverage_headers",
                "date_parsing_error",
                "number_parsing_error",
                "large_number_warning",
                "suspicious_year_warning",
                "year_out_of_range_warning",
                "general_mismatch",
                "low_confidence",
                "medium_confidence",
                "non_property_insurance_value",
                "unrecognized_central_alarm_value",
                "unrecognized_yes_no_value",
                "low_sprinkler_percentage",
                "unrecognized_sprinkler_value",
                "zip_parsing_error",
                "blank_tiv_value",
                "non_ascii_removed",
                "address_corrected_by_geocoding",
                "geocoding_failed",
                "location_number_mismatch",
                "year_defaulted_to_year_built",
                "approximate_geocoding",
                "high_protection_class",
                "tier_1_wind_zone",
                "itv_calc_warning",
                "bi_estimate_warning",
                "coverage_adjusted_by_reconciliation",
                "zip_unrecognized",
                "zip_not_rater_valid",
                "zip_state_mismatch",
                "number_of_buildings_replaced",
              ],
            },
            {
              $ref: "#/components/schemas/UnknownCoverageColumnFlag",
            },
            {
              $ref: "#/components/schemas/UnknownInsuranceSubjectFlag",
            },
            {
              $ref: "#/components/schemas/AddressCorrectedByModel",
            },
            {
              $ref: "#/components/schemas/AddressFlaggedByGeocoding",
            },
            {
              $ref: "#/components/schemas/CoverageComputedFromColumnSum",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Private Flags",
    },
    ofac_result: {
      anyOf: [
        {
          $ref: "#/components/schemas/OFACResult",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "address_id",
    "private_computed_values",
    "private_original_values",
    "private_overrides",
    "private_flags",
  ],
  title: "Address",
} as const;

export const $AddressCorrectedByModel = {
  properties: {
    flag_id: {
      type: "string",
      const: "address_corrected_by_llm_parse",
      title: "Flag Id",
    },
    original: {
      type: "string",
      title: "Original",
    },
  },
  type: "object",
  required: ["flag_id", "original"],
  title: "AddressCorrectedByModel",
} as const;

export const $AddressFlaggedByGeocoding = {
  properties: {
    flag_id: {
      type: "string",
      const: "address_flagged_by_geocoding",
      title: "Flag Id",
    },
    geocoded: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded",
    },
  },
  type: "object",
  required: ["flag_id", "geocoded"],
  title: "AddressFlaggedByGeocoding",
} as const;

export const $AddressIntegrationData = {
  properties: {
    rms: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    air: {
      anyOf: [
        {
          $ref: "#/components/schemas/AIRLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    spatialkat: {
      anyOf: [
        {
          $ref: "#/components/schemas/SpatialKatLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    geographic_enrichment: {
      anyOf: [
        {
          $ref: "#/components/schemas/GeographicEnrichmentData",
        },
        {
          type: "null",
        },
      ],
    },
    hazard_hub: {
      anyOf: [
        {
          $ref: "#/components/schemas/HazardHubData",
        },
        {
          type: "null",
        },
      ],
    },
    nearmap: {
      anyOf: [
        {
          $ref: "#/components/schemas/NearmapData",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "AddressIntegrationData",
} as const;

export const $AddressList = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "AddressList",
} as const;

export const $AdvancedDeductible = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    short_deductible_description: {
      type: "string",
      title: "Short Deductible Description",
    },
    executable_python_function_str: {
      type: "string",
      title: "Executable Python Function Str",
    },
    direct_excerpts: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Direct Excerpts",
    },
    manual_excerpt_overrides: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Excerpt Overrides",
    },
    removed_excerpt_names: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Removed Excerpt Names",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "short_deductible_description",
    "executable_python_function_str",
  ],
  title: "AdvancedDeductible",
} as const;

export const $AdvancedDeductibleInfo = {
  properties: {
    extracted_deductibles: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/AdvancedDeductible",
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Deductibles",
    },
    manual_deductibles: {
      additionalProperties: {
        $ref: "#/components/schemas/AdvancedDeductible",
      },
      type: "object",
      title: "Manual Deductibles",
    },
  },
  type: "object",
  required: ["extracted_deductibles", "manual_deductibles"],
  title: "AdvancedDeductibleInfo",
} as const;

export const $AdvancedLimit = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    short_limit_description: {
      type: "string",
      title: "Short Limit Description",
    },
    document_quotation: {
      type: "string",
      title: "Document Quotation",
    },
    executable_python_function_str: {
      type: "string",
      title: "Executable Python Function Str",
    },
    direct_excerpts: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Direct Excerpts",
    },
    manual_excerpt_overrides: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Excerpt Overrides",
    },
    removed_excerpt_names: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Removed Excerpt Names",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "short_limit_description",
    "document_quotation",
    "executable_python_function_str",
  ],
  title: "AdvancedLimit",
} as const;

export const $AdvancedLimitInfo = {
  properties: {
    extracted_limits: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/AdvancedLimit",
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Limits",
    },
    manual_limits: {
      additionalProperties: {
        $ref: "#/components/schemas/AdvancedLimit",
      },
      type: "object",
      title: "Manual Limits",
    },
  },
  type: "object",
  required: ["extracted_limits", "manual_limits"],
  title: "AdvancedLimitInfo",
} as const;

export const $Appetite = {
  properties: {
    appetite_result: {
      type: "string",
      enum: [
        "in_appetite",
        "sic_codes_invalid",
        "no_sov_file",
        "no_loss_run_file",
        "far_away_effective_date",
        "low_tiv",
        "prior_submission",
        "missing_cope_info",
        "foreign_exposure",
      ],
      title: "Appetite Result",
    },
    appetite_results: {
      items: {
        type: "string",
        enum: [
          "in_appetite",
          "sic_codes_invalid",
          "no_sov_file",
          "no_loss_run_file",
          "far_away_effective_date",
          "low_tiv",
          "prior_submission",
          "missing_cope_info",
          "foreign_exposure",
        ],
      },
      type: "array",
      title: "Appetite Results",
    },
  },
  type: "object",
  required: ["appetite_result"],
  title: "Appetite",
} as const;

export const $Attachment = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    from_email: {
      type: "boolean",
      title: "From Email",
    },
    original_mapping: {
      type: "string",
      enum: [
        "sov_spreadsheet",
        "acord_app",
        "loss_run",
        "none",
        "screenshot",
        "allied_policy",
        "rater",
        "loss_control_report",
        "policy_document",
        "specs_sheet",
        "record_keeping",
        "luminor_quote",
        "luminor_tria",
        "luminor_binder",
        "luminor_policy",
        "lead_quote",
        "lead_binder",
        "lead_policy",
        "bound_sov",
        "sl_letter",
      ],
      title: "Original Mapping",
    },
    manual_mapping: {
      anyOf: [
        {
          type: "string",
          enum: [
            "sov_spreadsheet",
            "acord_app",
            "loss_run",
            "none",
            "screenshot",
            "allied_policy",
            "rater",
            "loss_control_report",
            "policy_document",
            "specs_sheet",
            "record_keeping",
            "luminor_quote",
            "luminor_tria",
            "luminor_binder",
            "luminor_policy",
            "lead_quote",
            "lead_binder",
            "lead_policy",
            "bound_sov",
            "sl_letter",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Manual Mapping",
    },
    source: {
      anyOf: [
        {
          type: "string",
          enum: ["email", "screenshot_tool", "user_upload"],
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
    conversation_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Conversation Id",
    },
  },
  type: "object",
  required: ["name", "from_email", "original_mapping", "manual_mapping"],
  title: "Attachment",
} as const;

export const $AttachmentInfo = {
  properties: {
    attachments: {
      items: {
        $ref: "#/components/schemas/Attachment",
      },
      type: "array",
      title: "Attachments",
    },
  },
  type: "object",
  required: ["attachments"],
  title: "AttachmentInfo",
} as const;

export const $AutoAssignmentStyle = {
  properties: {
    assignment_type: {
      type: "string",
      enum: ["round_robin", "override_in_email"],
      title: "Assignment Type",
    },
    original_assignee: {
      type: "string",
      title: "Original Assignee",
    },
  },
  type: "object",
  required: ["assignment_type", "original_assignee"],
  title: "AutoAssignmentStyle",
} as const;

export const $BatchCommentsRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
  },
  type: "object",
  required: ["report_ids"],
  title: "BatchCommentsRequest",
} as const;

export const $BatchCommentsResponse = {
  properties: {
    comments_by_report_id: {
      additionalProperties: {
        $ref: "#/components/schemas/Comments",
      },
      type: "object",
      title: "Comments By Report Id",
    },
  },
  type: "object",
  required: ["comments_by_report_id"],
  title: "BatchCommentsResponse",
} as const;

export const $Body_asgard_create_template_asgard_create_template_post = {
  properties: {
    template: {
      type: "string",
      format: "binary",
      title: "Template",
    },
  },
  type: "object",
  required: ["template"],
  title: "Body_asgard_create_template_asgard_create_template_post",
} as const;

export const $Body_asgard_upload_additional_file_asgard_upload_additional_files_post =
  {
    properties: {
      files: {
        items: {
          type: "string",
          format: "binary",
        },
        type: "array",
        title: "Files",
      },
    },
    type: "object",
    required: ["files"],
    title:
      "Body_asgard_upload_additional_file_asgard_upload_additional_files_post",
  } as const;

export const $Body_asgard_upload_email_thread_asgard_upload_email_thread_post =
  {
    properties: {
      files: {
        items: {
          type: "string",
          format: "binary",
        },
        type: "array",
        title: "Files",
      },
    },
    type: "object",
    required: ["files"],
    title: "Body_asgard_upload_email_thread_asgard_upload_email_thread_post",
  } as const;

export const $Body_asgard_upload_emls_asgard_upload_emls_post = {
  properties: {
    files: {
      items: {
        type: "string",
        format: "binary",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "Body_asgard_upload_emls_asgard_upload_emls_post",
} as const;

export const $Body_login_login_post = {
  properties: {
    grant_type: {
      anyOf: [
        {
          type: "string",
          pattern: "password",
        },
        {
          type: "null",
        },
      ],
      title: "Grant Type",
    },
    username: {
      type: "string",
      title: "Username",
    },
    password: {
      type: "string",
      title: "Password",
    },
    scope: {
      type: "string",
      title: "Scope",
      default: "",
    },
    client_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Id",
    },
    client_secret: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Secret",
    },
  },
  type: "object",
  required: ["username", "password"],
  title: "Body_login_login_post",
} as const;

export const $BookSummaryResponse = {
  properties: {
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    states: {
      items: {
        $ref: "#/components/schemas/StateSummary",
      },
      type: "array",
      title: "States",
    },
  },
  type: "object",
  required: ["total_tiv", "states"],
  title: "BookSummaryResponse",
} as const;

export const $BorLetterListResponse = {
  properties: {
    bor_letters: {
      items: {
        $ref: "#/components/schemas/BorLetterResponse",
      },
      type: "array",
      title: "Bor Letters",
    },
  },
  type: "object",
  required: ["bor_letters"],
  title: "BorLetterListResponse",
} as const;

export const $BorLetterResponse = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    cleared_report_id: {
      type: "string",
      title: "Cleared Report Id",
    },
    incoming_report_id: {
      type: "string",
      title: "Incoming Report Id",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
    created_by: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Created By",
    },
    received_at: {
      type: "string",
      format: "date-time",
      title: "Received At",
    },
    outgoing_broker_notified_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Outgoing Broker Notified At",
    },
    incoming_broker_notified_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Incoming Broker Notified At",
    },
    rescind_letter_received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Rescind Letter Received At",
    },
    finalized_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Finalized At",
    },
    outgoing_broker_resolution_sent_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Outgoing Broker Resolution Sent At",
    },
    incoming_broker_resolution_sent_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Incoming Broker Resolution Sent At",
    },
    rescind_deadline: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Rescind Deadline",
    },
    is_resolved: {
      type: "boolean",
      title: "Is Resolved",
    },
    notification_sla_deadline: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Notification Sla Deadline",
    },
    notifications_sent: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Notifications Sent",
    },
  },
  type: "object",
  required: [
    "id",
    "client_id",
    "cleared_report_id",
    "incoming_report_id",
    "effective_date",
    "notes",
    "created_by",
    "received_at",
    "outgoing_broker_notified_at",
    "incoming_broker_notified_at",
    "rescind_letter_received_at",
    "finalized_at",
    "outgoing_broker_resolution_sent_at",
    "incoming_broker_resolution_sent_at",
    "rescind_deadline",
    "is_resolved",
    "notification_sla_deadline",
    "notifications_sent",
  ],
  title: "BorLetterResponse",
} as const;

export const $BuildingData = {
  properties: {
    id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    roof_age_years: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Age Years",
    },
    materials: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Materials",
    },
    shapes: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Shapes",
    },
  },
  type: "object",
  title: "BuildingData",
  description:
    "One building/structure on the parcel, joining buildings + roof_age + geoJson.",
} as const;

export const $BulkEditRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    field: {
      type: "string",
      title: "Field",
    },
    instructions: {
      type: "string",
      title: "Instructions",
    },
  },
  type: "object",
  required: ["report_id", "field", "instructions"],
  title: "BulkEditRequest",
} as const;

export const $BulkEditResponse = {
  properties: {
    before: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Before",
    },
    after: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "After",
    },
  },
  type: "object",
  required: ["before", "after"],
  title: "BulkEditResponse",
} as const;

export const $CalculatePremiumRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    batch_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "CalculatePremiumRequest",
} as const;

export const $CalculatedPremiumResponse = {
  properties: {
    layers: {
      items: {
        $ref: "#/components/schemas/LayerPremiumBreakdown",
      },
      type: "array",
      title: "Layers",
    },
    errors: {
      items: {
        $ref: "#/components/schemas/PremiumError",
      },
      type: "array",
      title: "Errors",
      default: [],
    },
  },
  type: "object",
  required: ["layers"],
  title: "CalculatedPremiumResponse",
} as const;

export const $CancelJobRequest = {
  properties: {
    report_integration_id: {
      type: "string",
      title: "Report Integration Id",
    },
  },
  type: "object",
  required: ["report_integration_id"],
  title: "CancelJobRequest",
} as const;

export const $CancelJobResponse = {
  properties: {},
  type: "object",
  title: "CancelJobResponse",
} as const;

export const $CatAggregateData = {
  properties: {
    aal_combined_groundup: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Combined Groundup",
    },
    aal_per_peril_groundup: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Per Peril Groundup",
      default: {},
    },
    layers: {
      items: {
        $ref: "#/components/schemas/CatLayerResult",
      },
      type: "array",
      title: "Layers",
      default: [],
    },
    ep_curves: {
      items: {
        $ref: "#/components/schemas/EPRow",
      },
      type: "array",
      title: "Ep Curves",
      default: [],
    },
    standard_deviation_combined_groundup: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Standard Deviation Combined Groundup",
    },
    standard_deviation_per_peril_groundup: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Standard Deviation Per Peril Groundup",
      default: {},
    },
  },
  type: "object",
  title: "CatAggregateData",
} as const;

export const $CatIcmResults = {
  properties: {
    air: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    rms: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "CatIcmResults",
} as const;

export const $CatJobHistoryItem = {
  properties: {
    type: {
      type: "string",
      enum: ["icm", "rms", "spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
      default: 0,
    },
    total_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Aal",
    },
    total_tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    num_layers: {
      type: "integer",
      title: "Num Layers",
      default: 0,
    },
    is_test: {
      type: "boolean",
      title: "Is Test",
      default: false,
    },
    sub_tasks_count: {
      type: "integer",
      title: "Sub Tasks Count",
      default: 0,
    },
    sub_tasks_completed: {
      type: "integer",
      title: "Sub Tasks Completed",
      default: 0,
    },
  },
  type: "object",
  required: ["type", "batch_id", "status", "started_at", "finished_at"],
  title: "CatJobHistoryItem",
} as const;

export const $CatJobHistoryResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/CatJobHistoryItem",
      },
      type: "array",
      title: "Jobs",
      default: [],
    },
  },
  type: "object",
  title: "CatJobHistoryResponse",
} as const;

export const $CatLayerResult = {
  properties: {
    layer_guid: {
      type: "string",
      title: "Layer Guid",
    },
    perils: {
      additionalProperties: {
        $ref: "#/components/schemas/CatPerilLayerData",
      },
      type: "object",
      title: "Perils",
      default: {},
    },
    totals: {
      $ref: "#/components/schemas/CatPerilLayerData",
      default: {
        pml_per_period: {},
      },
    },
    ep_curves: {
      items: {
        $ref: "#/components/schemas/EPRow",
      },
      type: "array",
      title: "Ep Curves",
      default: [],
    },
    locations: {
      items: {
        $ref: "#/components/schemas/CatLocationWithAddress",
      },
      type: "array",
      title: "Locations",
      default: [],
    },
  },
  type: "object",
  required: ["layer_guid"],
  title: "CatLayerResult",
} as const;

export const $CatLocationWithAddress = {
  properties: {
    aal_combined: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Combined",
    },
    aal_per_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Per Peril",
      default: {},
    },
    address: {
      anyOf: [
        {
          $ref: "#/components/schemas/LocationAddress",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  title: "CatLocationWithAddress",
} as const;

export const $CatPerilLayerData = {
  properties: {
    aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal",
    },
    pml_per_period: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["100", "250", "1000"],
      },
      type: "object",
      title: "Pml Per Period",
      default: {},
    },
  },
  type: "object",
  title: "CatPerilLayerData",
} as const;

export const $CatPrecheckResponse = {
  properties: {
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    icm: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
    rms: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
    spatialkat: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
  },
  type: "object",
  required: ["warnings", "icm", "rms", "spatialkat"],
  title: "CatPrecheckResponse",
  description: `What the user sees on cat tab load — human-readable warnings about
foreign exposure, geocoding gaps, and location limits, per vendor.`,
} as const;

export const $CatRerunFinancialResult = {
  properties: {
    integration_type: {
      type: "string",
      enum: ["rms_elt", "rms_22", "icm_ylt"],
      title: "Integration Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    source_batch_id: {
      type: "string",
      title: "Source Batch Id",
    },
  },
  type: "object",
  required: ["integration_type", "batch_id", "source_batch_id"],
  title: "CatRerunFinancialResult",
  description: `Result of kicking off a financial-only re-run for a cat integration.

\`\`batch_id\`\` is the new batch created for the re-run (poll it for
progress); \`\`source_batch_id\`\` is the original batch whose cached
model artifacts are reused.`,
} as const;

export const $CatResultsResponse = {
  properties: {
    icm: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatIcmResults",
        },
        {
          type: "null",
        },
      ],
    },
    rms: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    rms_elt: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    rms_22: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    spatialkat: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    icm_ylt: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "CatResultsResponse",
} as const;

export const $CatResumeResult = {
  properties: {
    integration_type: {
      type: "string",
      enum: ["rms_elt", "rms_22", "icm_ylt"],
      title: "Integration Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["integration_type", "batch_id"],
  title: "CatResumeResult",
  description: `Result of resuming a cat integration's batch in place. \`\`batch_id\`\`
is the resumed batch — poll it for progress, exactly as for a normal
run.`,
} as const;

export const $CatSourceData = {
  properties: {
    aggregate: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatAggregateData",
        },
        {
          type: "null",
        },
      ],
    },
    locations: {
      items: {
        $ref: "#/components/schemas/CatLocationWithAddress",
      },
      type: "array",
      title: "Locations",
      default: [],
    },
    top_locations_by_peril: {
      additionalProperties: {
        items: {
          $ref: "#/components/schemas/CatTopLocation",
        },
        type: "array",
      },
      type: "object",
      title: "Top Locations By Peril",
      default: {},
    },
  },
  type: "object",
  title: "CatSourceData",
  description: "Aggregate + location results for one modeling source.",
} as const;

export const $CatTopLocation = {
  properties: {
    aal: {
      type: "number",
      title: "Aal",
    },
    tiv_pct: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Pct",
    },
    aal_pct: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Pct",
    },
    address: {
      anyOf: [
        {
          $ref: "#/components/schemas/LocationAddress",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["aal"],
  title: "CatTopLocation",
} as const;

export const $Chart = {
  properties: {
    title: {
      type: "string",
      title: "Title",
    },
    data: {
      items: {
        $ref: "#/components/schemas/DataPoint",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["title", "data"],
  title: "Chart",
} as const;

export const $ChartGroup = {
  properties: {
    title: {
      type: "string",
      title: "Title",
    },
    charts: {
      items: {
        $ref: "#/components/schemas/Chart",
      },
      type: "array",
      title: "Charts",
    },
  },
  type: "object",
  required: ["title", "charts"],
  title: "ChartGroup",
} as const;

export const $CheckBorDeadlinesResponse = {
  properties: {
    alerts_sent: {
      type: "integer",
      title: "Alerts Sent",
    },
    alerts: {
      items: {
        additionalProperties: {
          anyOf: [
            {
              type: "string",
            },
            {
              type: "null",
            },
          ],
        },
        type: "object",
      },
      type: "array",
      title: "Alerts",
    },
  },
  type: "object",
  required: ["alerts_sent", "alerts"],
  title: "CheckBorDeadlinesResponse",
} as const;

export const $ClearanceEmailRecipientsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "ClearanceEmailRecipientsRequest",
} as const;

export const $ClearanceEmailRecipientsResponse = {
  properties: {
    recipients: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Recipients",
    },
    locked_emails: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Locked Emails",
    },
  },
  type: "object",
  required: ["recipients", "locked_emails"],
  title: "ClearanceEmailRecipientsResponse",
} as const;

export const $Comment = {
  properties: {
    message: {
      type: "string",
      title: "Message",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    last_updated_ts: {
      type: "string",
      format: "date-time",
      title: "Last Updated Ts",
    },
    user_id: {
      type: "string",
      title: "User Id",
    },
    id: {
      type: "string",
      title: "Id",
    },
    deleted: {
      type: "boolean",
      title: "Deleted",
      default: false,
    },
  },
  type: "object",
  required: ["message", "created_at_ts", "last_updated_ts", "user_id", "id"],
  title: "Comment",
} as const;

export const $Comments = {
  properties: {
    all_comments: {
      items: {
        $ref: "#/components/schemas/Comment",
      },
      type: "array",
      title: "All Comments",
    },
  },
  type: "object",
  required: ["all_comments"],
  title: "Comments",
} as const;

export const $CommercialReport = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    naics_info: {
      $ref: "#/components/schemas/NaicsInfo",
    },
    sovs: {
      items: {
        $ref: "#/components/schemas/SOV",
      },
      type: "array",
      title: "Sovs",
    },
    loss_run: {
      $ref: "#/components/schemas/LossRunInfo",
    },
    company_info: {
      $ref: "#/components/schemas/CompanyInfo",
    },
    layer_info: {
      items: {
        $ref: "#/components/schemas/Layer",
      },
      type: "array",
      title: "Layer Info",
    },
    ofac_result: {
      anyOf: [
        {
          $ref: "#/components/schemas/OFACResult",
        },
        {
          type: "null",
        },
      ],
    },
    policy_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    policy_questions: {
      anyOf: [
        {
          additionalProperties: {
            items: {
              $ref: "#/components/schemas/PolicyQuestion",
            },
            type: "array",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Questions",
    },
    additional_files_used: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Files Used",
    },
    loss_control_reports: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/LossControlReport",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Control Reports",
    },
    attachment_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AttachmentInfo",
        },
        {
          type: "null",
        },
      ],
    },
    referral_text: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReferralText",
        },
        {
          type: "null",
        },
      ],
    },
    policy_questions_for_policy_documents: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyQuestionsForDocuments",
        },
        {
          type: "null",
        },
      ],
    },
    limit_and_sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LimitAndSublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedLimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/SublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    deductible_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedDeductibleInfo",
        },
        {
          type: "null",
        },
      ],
    },
    submission_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Submission Recipients",
    },
    policy_fly_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Fly Url",
    },
    policy_fly_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyFlyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    email_threads: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Email Threads",
    },
  },
  type: "object",
  required: [
    "report_id",
    "naics_info",
    "sovs",
    "loss_run",
    "company_info",
    "layer_info",
  ],
  title: "CommercialReport",
} as const;

export const $CommericalReportMetadata = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    naics_info: {
      $ref: "#/components/schemas/NaicsInfo",
    },
    company_info: {
      $ref: "#/components/schemas/CompanyInfo",
    },
    precomputed_metadata: {
      $ref: "#/components/schemas/PrecomputedMetadata",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "naics_info",
    "company_info",
    "precomputed_metadata",
  ],
  title: "CommericalReportMetadata",
} as const;

export const $CompanyInfo = {
  properties: {
    private_computed_values: {
      $ref: "#/components/schemas/RawCompanyInfo",
    },
    private_original_values: {
      additionalProperties: {
        anyOf: [
          {
            items: {
              type: "string",
            },
            type: "array",
          },
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Original Values",
    },
    private_overrides: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            items: {
              type: "string",
            },
            type: "array",
          },
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Overrides",
    },
    private_flags: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              type: "string",
              enum: [
                "low_confidence",
                "medium_confidence",
                "modified_by_sanitization",
                "default_used",
                "could_not_sanitize",
                "po_box_insured_address",
              ],
            },
            {
              $ref: "#/components/schemas/YearIncorporatedDerivedFromSearch",
            },
            {
              $ref: "#/components/schemas/MultipleCompanyNamesFlag",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Private Flags",
    },
    additional_interests: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/OverrideableListElement_RawAdditionalInterest_Literal__todo___",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Interests",
    },
  },
  type: "object",
  required: [
    "private_computed_values",
    "private_original_values",
    "private_overrides",
    "private_flags",
  ],
  title: "CompanyInfo",
} as const;

export const $CompetitorPricing = {
  properties: {
    carrier_name: {
      type: "string",
      title: "Carrier Name",
    },
    price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Price",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["carrier_name", "price", "notes"],
  title: "CompetitorPricing",
} as const;

export const $ComputedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    source: {
      type: "string",
      const: "computed_from_claims",
      title: "Source",
    },
    claims: {
      items: {
        anyOf: [
          {
            $ref: "#/components/schemas/ParsedLoss",
          },
          {
            $ref: "#/components/schemas/UserGeneratedLoss",
          },
        ],
      },
      type: "array",
      title: "Claims",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "source",
    "claims",
  ],
  title: "ComputedLossRunByYear",
} as const;

export const $ConstructionMix = {
  properties: {
    construction_description: {
      type: "string",
      title: "Construction Description",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["construction_description", "tiv", "pct_tiv"],
  title: "ConstructionMix",
} as const;

export const $ContactType = {
  type: "string",
  enum: ["broker"],
  title: "ContactType",
  description: "Contact type enum for categorizing contacts.",
} as const;

export const $CoverageComputedFromColumnSum = {
  properties: {
    flag_id: {
      type: "string",
      const: "coverage_computed_from_column_sum",
      title: "Flag Id",
    },
    columns: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Columns",
    },
  },
  type: "object",
  required: ["flag_id", "columns"],
  title: "CoverageComputedFromColumnSum",
} as const;

export const $CreateBorLetterRequest = {
  properties: {
    cleared_report_id: {
      type: "string",
      title: "Cleared Report Id",
    },
    incoming_report_id: {
      type: "string",
      title: "Incoming Report Id",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["cleared_report_id", "incoming_report_id"],
  title: "CreateBorLetterRequest",
} as const;

export const $CreateContactRequest = {
  properties: {
    email: {
      type: "string",
      title: "Email",
    },
    contact_type: {
      $ref: "#/components/schemas/ContactType",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  required: ["email", "contact_type", "full_name"],
  title: "CreateContactRequest",
  description: "Request body for creating a contact.",
} as const;

export const $CreateContactResponse = {
  properties: {
    contact: {
      $ref: "#/components/schemas/ReportContact",
    },
  },
  type: "object",
  required: ["contact"],
  title: "CreateContactResponse",
} as const;

export const $DataPoint = {
  properties: {
    label: {
      type: "string",
      title: "Label",
    },
    value: {
      type: "number",
      title: "Value",
    },
    color_code: {
      type: "string",
      enum: [
        "green",
        "yellow",
        "red",
        "blue",
        "purple",
        "teal",
        "gray",
        "orange",
        "pink",
        "indigo",
        "cyan",
        "lime",
      ],
      title: "Color Code",
    },
    type: {
      type: "string",
      enum: ["percentage", "monetary", "count"],
      title: "Type",
    },
  },
  type: "object",
  required: ["label", "value", "color_code", "type"],
  title: "DataPoint",
} as const;

export const $DeductibleEntry = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["name", "description"],
  title: "DeductibleEntry",
} as const;

export const $DeductibleSummary = {
  properties: {
    kind: {
      type: "string",
      enum: ["site", "per_unit", "occurrence", "aggregate"],
      title: "Kind",
    },
    value: {
      type: "number",
      title: "Value",
    },
    zone: {
      type: "string",
      title: "Zone",
    },
  },
  type: "object",
  required: ["kind", "value", "zone"],
  title: "DeductibleSummary",
} as const;

export const $DeductibleSummaryRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "address_ids"],
  title: "DeductibleSummaryRequest",
} as const;

export const $DeductibleSummaryResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/DeductibleSummary",
        },
        propertyNames: {
          enum: ["PWH", "PES", "PFL", "PWB", "PWT", "AOP"],
        },
        type: "object",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "DeductibleSummaryResponse",
} as const;

export const $DeleteAdditionalFilesRequest = {
  properties: {
    files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "DeleteAdditionalFilesRequest",
} as const;

export const $DeleteAdditionalFilesResponse = {
  properties: {
    files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "DeleteAdditionalFilesResponse",
} as const;

export const $DeleteAttachmentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: ["report_id", "filename"],
  title: "DeleteAttachmentRequest",
} as const;

export const $DeleteCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    comment_id: {
      type: "string",
      title: "Comment Id",
    },
  },
  type: "object",
  required: ["report_id", "comment_id"],
  title: "DeleteCommentRequest",
} as const;

export const $DeleteCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "DeleteCommentResponse",
} as const;

export const $DeleteEmailThreadRequest = {
  properties: {
    conversation_id: {
      type: "string",
      title: "Conversation Id",
    },
  },
  type: "object",
  required: ["conversation_id"],
  title: "DeleteEmailThreadRequest",
} as const;

export const $DeleteEmailThreadResponse = {
  properties: {
    deleted_files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Deleted Files",
    },
  },
  type: "object",
  required: ["deleted_files"],
  title: "DeleteEmailThreadResponse",
} as const;

export const $DeleteReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "DeleteReportRequest",
} as const;

export const $DeleteReportResponse = {
  properties: {},
  type: "object",
  title: "DeleteReportResponse",
} as const;

export const $DeleteSavedFilterRequest = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
  },
  type: "object",
  required: ["id"],
  title: "DeleteSavedFilterRequest",
} as const;

export const $DeleteTemplate = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
  },
  type: "object",
  required: ["template_id"],
  title: "DeleteTemplate",
} as const;

export const $DownloadAdditionalFileRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    file: {
      type: "string",
      title: "File",
    },
  },
  type: "object",
  required: ["report_id", "file"],
  title: "DownloadAdditionalFileRequest",
} as const;

export const $DownloadLossRunRequest = {
  properties: {
    loss_run_years: {
      items: {
        $ref: "#/components/schemas/UserGeneratedLossRunByYear",
      },
      type: "array",
      title: "Loss Run Years",
    },
  },
  type: "object",
  required: ["loss_run_years"],
  title: "DownloadLossRunRequest",
} as const;

export const $DownloadReportFileRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: ["report_id", "filename"],
  title: "DownloadReportFileRequest",
} as const;

export const $DownloadReportHistoryRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    download_type: {
      type: "string",
      enum: ["account", "simple_location", "complex_location"],
      title: "Download Type",
    },
  },
  type: "object",
  required: ["report_ids", "download_type"],
  title: "DownloadReportHistoryRequest",
} as const;

export const $DownloadTemplateRequest = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
  },
  type: "object",
  required: ["template_id"],
  title: "DownloadTemplateRequest",
} as const;

export const $DownloadThreadAttachmentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    thread_url: {
      type: "string",
      title: "Thread Url",
    },
    message_id: {
      type: "string",
      title: "Message Id",
    },
    attachment_id: {
      type: "string",
      title: "Attachment Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: [
    "report_id",
    "thread_url",
    "message_id",
    "attachment_id",
    "filename",
  ],
  title: "DownloadThreadAttachmentRequest",
} as const;

export const $DraftResponse = {
  properties: {
    draft_url: {
      type: "string",
      title: "Draft Url",
    },
  },
  type: "object",
  required: ["draft_url"],
  title: "DraftResponse",
} as const;

export const $EPRow = {
  properties: {
    peril: {
      type: "string",
      title: "Peril",
    },
    perspective: {
      type: "string",
      title: "Perspective",
    },
    metric_type: {
      type: "string",
      title: "Metric Type",
    },
    return_period_values: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Return Period Values",
      default: {},
    },
  },
  type: "object",
  required: ["peril", "perspective", "metric_type"],
  title: "EPRow",
} as const;

export const $EditCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    comment_id: {
      type: "string",
      title: "Comment Id",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["report_id", "comment_id", "message"],
  title: "EditCommentRequest",
} as const;

export const $EditCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "EditCommentResponse",
} as const;

export const $EmailThread = {
  properties: {
    thread_url: {
      type: "string",
      title: "Thread Url",
    },
    messages: {
      items: {
        $ref: "#/components/schemas/EmailThreadMessage",
      },
      type: "array",
      title: "Messages",
    },
  },
  type: "object",
  required: ["thread_url", "messages"],
  title: "EmailThread",
} as const;

export const $EmailThreadAttachment = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    mime_type: {
      type: "string",
      title: "Mime Type",
    },
    size: {
      type: "integer",
      title: "Size",
    },
    attachment_id: {
      type: "string",
      title: "Attachment Id",
    },
    message_id: {
      type: "string",
      title: "Message Id",
    },
  },
  type: "object",
  required: ["filename", "mime_type", "size", "attachment_id", "message_id"],
  title: "EmailThreadAttachment",
} as const;

export const $EmailThreadMessage = {
  properties: {
    from: {
      type: "string",
      title: "From",
      default: "",
    },
    to: {
      type: "string",
      title: "To",
      default: "",
    },
    cc: {
      type: "string",
      title: "Cc",
      default: "",
    },
    subject: {
      type: "string",
      title: "Subject",
      default: "",
    },
    date: {
      type: "string",
      title: "Date",
      default: "",
    },
    body_text: {
      type: "string",
      title: "Body Text",
      default: "",
    },
    body_html: {
      type: "string",
      title: "Body Html",
      default: "",
    },
    attachments: {
      items: {
        $ref: "#/components/schemas/EmailThreadAttachment",
      },
      type: "array",
      title: "Attachments",
      default: [],
    },
  },
  type: "object",
  title: "EmailThreadMessage",
} as const;

export const $EmailThreadsResponse = {
  properties: {
    threads: {
      items: {
        $ref: "#/components/schemas/EmailThread",
      },
      type: "array",
      title: "Threads",
    },
  },
  type: "object",
  required: ["threads"],
  title: "EmailThreadsResponse",
} as const;

export const $EmlPreviewRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "EmlPreviewRequest",
} as const;

export const $EmlPreviewResponse = {
  properties: {
    subject: {
      type: "string",
      title: "Subject",
    },
    eml: {
      type: "string",
      title: "Eml",
    },
  },
  type: "object",
  required: ["subject", "eml"],
  title: "EmlPreviewResponse",
} as const;

export const $ExposureData = {
  properties: {
    fema_flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Flood Zone",
    },
    wind_pool_score: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Pool Score",
    },
  },
  type: "object",
  title: "ExposureData",
  description:
    "Exposure (E) from COPE — external hazard exposure beyond peril scores.",
} as const;

export const $GeneratePolicyFlyApplicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    perils_by_layer: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Perils By Layer",
    },
    additional_layer_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Layer Id",
    },
  },
  type: "object",
  required: ["report_id", "perils_by_layer", "additional_layer_id"],
  title: "GeneratePolicyFlyApplicationRequest",
} as const;

export const $GeneratePolicyFlyApplicationResponse = {
  properties: {
    task_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Task Ids",
    },
  },
  type: "object",
  required: ["task_ids"],
  title: "GeneratePolicyFlyApplicationResponse",
} as const;

export const $GeneratePolicyNumbersRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "GeneratePolicyNumbersRequest",
} as const;

export const $GenerateQuoteIndicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    effective_perils: {
      items: {
        anyOf: [
          {
            type: "string",
            enum: [
              "aop",
              "earthquake",
              "earth_movement",
              "named_storm",
              "scs",
              "flood",
              "wildfire",
              "equipment_breakdown",
            ],
          },
          {
            type: "string",
            const: "wind_and_hail",
          },
        ],
      },
      type: "array",
      title: "Effective Perils",
    },
    perils_insured: {
      type: "string",
      title: "Perils Insured",
    },
    premium_range: {
      type: "string",
      title: "Premium Range",
    },
  },
  type: "object",
  required: [
    "report_id",
    "layer_id",
    "effective_perils",
    "perils_insured",
    "premium_range",
  ],
  title: "GenerateQuoteIndicationRequest",
} as const;

export const $GenerateUnderwritingPdfRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    html_content: {
      type: "string",
      title: "Html Content",
    },
  },
  type: "object",
  required: ["report_id", "html_content"],
  title: "GenerateUnderwritingPdfRequest",
} as const;

export const $GeneratedPolicyNumbers = {
  properties: {
    numbers: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Numbers",
    },
  },
  type: "object",
  required: ["numbers"],
  title: "GeneratedPolicyNumbers",
} as const;

export const $GeographicEnrichmentData = {
  properties: {
    flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Zone",
    },
    earthquake_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Earthquake Zone",
    },
  },
  type: "object",
  title: "GeographicEnrichmentData",
} as const;

export const $GetBorLetterRequest = {
  properties: {
    bor_id: {
      type: "string",
      title: "Bor Id",
    },
  },
  type: "object",
  required: ["bor_id"],
  title: "GetBorLetterRequest",
} as const;

export const $GetBorLettersByReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "GetBorLettersByReportRequest",
} as const;

export const $GetBrokerAnalyticsResponse = {
  properties: {
    chart_groups: {
      items: {
        $ref: "#/components/schemas/ChartGroup",
      },
      type: "array",
      title: "Chart Groups",
    },
  },
  type: "object",
  required: ["chart_groups"],
  title: "GetBrokerAnalyticsResponse",
} as const;

export const $GetReportActionLogRequest = {
  properties: {
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
  },
  type: "object",
  title: "GetReportActionLogRequest",
} as const;

export const $GetReportActionLogResponse = {
  properties: {
    company_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Name",
    },
    email_subject: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Subject",
    },
    actions: {
      items: {
        $ref: "#/components/schemas/ReportActionLogEntryResponse",
      },
      type: "array",
      title: "Actions",
    },
  },
  type: "object",
  required: ["actions"],
  title: "GetReportActionLogResponse",
} as const;

export const $GoogleGroupStats = {
  properties: {
    google_group_email: {
      type: "string",
      title: "Google Group Email",
    },
    ytd_year: {
      type: "integer",
      title: "Ytd Year",
    },
    submitted_count: {
      type: "integer",
      title: "Submitted Count",
    },
    quoted_count: {
      type: "integer",
      title: "Quoted Count",
    },
    bound_count: {
      type: "integer",
      title: "Bound Count",
    },
    not_cleared_count: {
      type: "integer",
      title: "Not Cleared Count",
    },
    avg_tiv: {
      type: "number",
      title: "Avg Tiv",
    },
    quoted_premium_ytd: {
      type: "integer",
      title: "Quoted Premium Ytd",
    },
    bound_premium_ytd: {
      type: "integer",
      title: "Bound Premium Ytd",
    },
    avg_bound_commission_ytd: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Avg Bound Commission Ytd",
    },
  },
  type: "object",
  required: [
    "google_group_email",
    "ytd_year",
    "submitted_count",
    "quoted_count",
    "bound_count",
    "not_cleared_count",
    "avg_tiv",
    "quoted_premium_ytd",
    "bound_premium_ytd",
    "avg_bound_commission_ytd",
  ],
  title: "GoogleGroupStats",
} as const;

export const $GoogleGroupStatsRequest = {
  properties: {
    google_group_email: {
      type: "string",
      title: "Google Group Email",
    },
  },
  type: "object",
  required: ["google_group_email"],
  title: "GoogleGroupStatsRequest",
} as const;

export const $HTTPValidationError = {
  properties: {
    detail: {
      items: {
        $ref: "#/components/schemas/ValidationError",
      },
      type: "array",
      title: "Detail",
    },
  },
  type: "object",
  title: "HTTPValidationError",
} as const;

export const $HazardHubData = {
  properties: {
    year_built: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Built",
    },
    number_of_stories: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Stories",
    },
    number_of_buildings: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Buildings",
    },
    building_condition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Condition",
    },
    basement: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Basement",
    },
    square_footage: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Square Footage",
    },
    replacement_cost: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Replacement Cost",
    },
    construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Quality",
    },
    construction_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Type",
    },
    primary_exterior: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Primary Exterior",
    },
    primary_roof_covering: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Primary Roof Covering",
    },
    roof_configuration: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Configuration",
    },
    distance_to_coast_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Distance To Coast Km",
    },
    occupancy: {
      $ref: "#/components/schemas/OccupancyData",
    },
    protection: {
      $ref: "#/components/schemas/ProtectionData",
    },
    exposure: {
      $ref: "#/components/schemas/ExposureData",
    },
    peril_scores: {
      $ref: "#/components/schemas/PerilScores",
    },
  },
  type: "object",
  title: "HazardHubData",
  description:
    "Normalized subset of HazardHub response fields mapped to address fields.",
} as const;

export const $IcmJobProgress = {
  properties: {
    submitted: {
      type: "boolean",
      title: "Submitted",
    },
    request_status: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Request Status",
    },
    stage: {
      anyOf: [
        {
          $ref: "#/components/schemas/IcmStage",
        },
        {
          type: "null",
        },
      ],
    },
    location_count: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Location Count",
    },
  },
  type: "object",
  required: ["submitted", "request_status", "stage", "location_count"],
  title: "IcmJobProgress",
} as const;

export const $IcmStage = {
  type: "string",
  enum: ["submitted", "cat_modeling", "scoring", "complete"],
  title: "IcmStage",
  description: `Coarse ICM-side progress for a rating request, derived from which
pipeline timestamps the status response has populated.`,
} as const;

export const $IcmYltInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "IcmYltInitiateRequest",
} as const;

export const $IcmYltInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "IcmYltInitiateResponse",
} as const;

export const $InitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "InitiateRequest",
  description: "Request body for initiating an ICM request.",
} as const;

export const $InitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "InitiateResponse",
} as const;

export const $InitiateTestRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    model_mode: {
      type: "string",
      enum: ["air", "rms", "both"],
      title: "Model Mode",
    },
    air_model_id: {
      type: "string",
      enum: ["22", "24"],
      title: "Air Model Id",
      default: "24",
    },
    peril_codes: {
      items: {
        type: "string",
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "array",
      title: "Peril Codes",
    },
    layer_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Layer Ids",
    },
    elevation_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Elevation Override",
    },
  },
  type: "object",
  required: ["report_id", "model_mode", "peril_codes", "layer_ids"],
  title: "InitiateTestRequest",
} as const;

export const $IntegrationDataRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    types: {
      items: {
        type: "string",
        enum: [
          "rms",
          "air",
          "spatialkat",
          "geographic_enrichment",
          "hazard_hub",
          "nearmap",
        ],
      },
      type: "array",
      title: "Types",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "types", "address_ids"],
  title: "IntegrationDataRequest",
} as const;

export const $IntegrationDataResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        $ref: "#/components/schemas/AddressIntegrationData",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "IntegrationDataResponse",
} as const;

export const $IntegrationStatusResult = {
  properties: {
    is_complete: {
      type: "boolean",
      title: "Is Complete",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    error_detail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Detail",
    },
  },
  type: "object",
  required: ["is_complete", "status"],
  title: "IntegrationStatusResult",
} as const;

export const $Layer = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    target: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Target",
    },
    rated: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Rated",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
    layer_source: {
      anyOf: [
        {
          type: "string",
          enum: ["extracted", "default", "manual"],
        },
        {
          type: "null",
        },
      ],
      title: "Layer Source",
    },
    is_enabled: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Enabled",
    },
    source_overrides: {
      anyOf: [
        {
          additionalProperties: {
            additionalProperties: {
              $ref: "#/components/schemas/SourceOverride",
            },
            type: "object",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Source Overrides",
    },
    competitor_pricing: {
      items: {
        $ref: "#/components/schemas/CompetitorPricing",
      },
      type: "array",
      title: "Competitor Pricing",
    },
  },
  type: "object",
  required: ["starting_point", "range", "target", "rated"],
  title: "Layer",
} as const;

export const $LayerPremiumBreakdown = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    peril_types: {
      additionalProperties: {
        $ref: "#/components/schemas/PerilTypeBreakdown",
      },
      type: "object",
      title: "Peril Types",
    },
    totals: {
      additionalProperties: {
        $ref: "#/components/schemas/LayerTotals",
      },
      type: "object",
      title: "Totals",
    },
    commission_adjustment_factor: {
      type: "number",
      title: "Commission Adjustment Factor",
      default: 1,
    },
    broker_commission_percentage: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Commission Percentage",
    },
  },
  type: "object",
  required: ["layer_id", "peril_types", "totals"],
  title: "LayerPremiumBreakdown",
} as const;

export const $LayerSummary = {
  properties: {
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
  },
  type: "object",
  required: ["starting_point", "range", "participation"],
  title: "LayerSummary",
} as const;

export const $LayerTotals = {
  properties: {
    layer_total: {
      type: "number",
      title: "Layer Total",
    },
    share_total: {
      type: "number",
      title: "Share Total",
    },
    has_missing_data: {
      type: "boolean",
      title: "Has Missing Data",
    },
  },
  type: "object",
  required: ["layer_total", "share_total", "has_missing_data"],
  title: "LayerTotals",
  description: "Precomputed totals for one source strategy on one layer.",
} as const;

export const $Limit = {
  properties: {
    limit_name: {
      type: "string",
      enum: [
        "earthquake",
        "earthmovement",
        "flood",
        "flood_high_hazard_sfha",
        "windstorm_named_windstorm_hurricane",
        "building_ordinance_coverage_a",
        "building_ordinance_coverage_b",
        "building_ordinance_coverage_c",
        "building_ordinance_coverage_d",
        "civil_or_military_authority",
        "ingress_egress",
        "debris_removal",
        "service_interruption",
        "contingent_time_element",
        "evacuation_expense",
        "electronic_data_and_media",
        "expediting_expenses",
        "fines_and_penalties",
        "property_in_the_open",
        "pairs_and_sets",
        "trees_shrubs_and_plants",
        "off_premises_storage",
        "outdoor_property",
        "land_improvements",
        "spoilage_perishable_foods",
        "piers_docks_wharfs_seawalls",
        "property_in_course_of_construction",
        "protection_and_preservation_of_property",
        "professional_fees",
        "animals_held_for_research",
        "research_and_development",
        "fire_brigade_and_extinguishing_expenses",
        "soft_costs",
        "vehicles_licensed_for_highway_use",
        "waterway_access",
        "extra_expense",
        "fine_arts",
        "land_water_contamination_and_cleanup_expense",
        "decontamination_costs",
        "leasehold_interest",
        "loss_adjustment_expenses",
        "personal_property_of_officers_and_employees",
        "employee_tools",
        "transit",
        "accounts_receivable",
        "mold_and_fungus",
        "errors_and_omissions",
        "miscellaneous_unnamed_locations",
        "newly_acquired_automatic_coverage",
        "extended_period_of_indemnity",
        "backup_of_sewers_and_drains_sump_overflow",
        "brands_and_labels",
        "code_upgrade_upgrade_to_green",
        "employee_personal_effects",
        "exhibition_trade_show_property",
        "freeze",
        "leader_property",
        "money_and_securities",
        "off_premises_property_temporary_locations",
        "refrigerated_property_temperature_change",
        "sprinkler_leakage",
        "strikes_riots_and_civil_commotion",
        "valuable_papers_and_records",
        "ordinary_payroll",
        "impounded_water",
        "land_and_water_cleanup_expense",
        "limited_pollution",
        "contractors_equipment",
        "rental_value",
        "royalties",
        "cyber",
        "asbestos",
        "equipment_breakdown",
        "consequential_loss",
        "cancellation_of_bookings",
      ],
      title: "Limit Name",
    },
    limit_status: {
      anyOf: [
        {
          type: "string",
          enum: ["included", "excluded"],
        },
        {
          type: "null",
        },
      ],
      title: "Limit Status",
    },
    applicability: {
      anyOf: [
        {
          type: "string",
          enum: ["per_occurrence", "per_occurrence_and_annual_aggregate"],
        },
        {
          type: "null",
        },
      ],
      title: "Applicability",
    },
    amount: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Amount",
    },
    time_limit_days: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Time Limit Days",
    },
    mile_limitation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Mile Limitation",
    },
    qualifying_period_hours: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Qualifying Period Hours",
    },
    document_excerpt: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Document Excerpt",
    },
  },
  type: "object",
  required: [
    "limit_name",
    "limit_status",
    "applicability",
    "amount",
    "time_limit_days",
    "mile_limitation",
    "qualifying_period_hours",
    "document_excerpt",
  ],
  title: "Limit",
} as const;

export const $LimitAndSublimitInfo = {
  properties: {
    extracted_limits: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/Limit",
        },
        propertyNames: {
          enum: [
            "earthquake",
            "earthmovement",
            "flood",
            "flood_high_hazard_sfha",
            "windstorm_named_windstorm_hurricane",
            "building_ordinance_coverage_a",
            "building_ordinance_coverage_b",
            "building_ordinance_coverage_c",
            "building_ordinance_coverage_d",
            "civil_or_military_authority",
            "ingress_egress",
            "debris_removal",
            "service_interruption",
            "contingent_time_element",
            "evacuation_expense",
            "electronic_data_and_media",
            "expediting_expenses",
            "fines_and_penalties",
            "property_in_the_open",
            "pairs_and_sets",
            "trees_shrubs_and_plants",
            "off_premises_storage",
            "outdoor_property",
            "land_improvements",
            "spoilage_perishable_foods",
            "piers_docks_wharfs_seawalls",
            "property_in_course_of_construction",
            "protection_and_preservation_of_property",
            "professional_fees",
            "animals_held_for_research",
            "research_and_development",
            "fire_brigade_and_extinguishing_expenses",
            "soft_costs",
            "vehicles_licensed_for_highway_use",
            "waterway_access",
            "extra_expense",
            "fine_arts",
            "land_water_contamination_and_cleanup_expense",
            "decontamination_costs",
            "leasehold_interest",
            "loss_adjustment_expenses",
            "personal_property_of_officers_and_employees",
            "employee_tools",
            "transit",
            "accounts_receivable",
            "mold_and_fungus",
            "errors_and_omissions",
            "miscellaneous_unnamed_locations",
            "newly_acquired_automatic_coverage",
            "extended_period_of_indemnity",
            "backup_of_sewers_and_drains_sump_overflow",
            "brands_and_labels",
            "code_upgrade_upgrade_to_green",
            "employee_personal_effects",
            "exhibition_trade_show_property",
            "freeze",
            "leader_property",
            "money_and_securities",
            "off_premises_property_temporary_locations",
            "refrigerated_property_temperature_change",
            "sprinkler_leakage",
            "strikes_riots_and_civil_commotion",
            "valuable_papers_and_records",
            "ordinary_payroll",
            "impounded_water",
            "land_and_water_cleanup_expense",
            "limited_pollution",
            "contractors_equipment",
            "rental_value",
            "royalties",
            "cyber",
            "asbestos",
            "equipment_breakdown",
            "consequential_loss",
            "cancellation_of_bookings",
          ],
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Limits",
    },
    manual_limits: {
      additionalProperties: {
        $ref: "#/components/schemas/Limit",
      },
      propertyNames: {
        enum: [
          "earthquake",
          "earthmovement",
          "flood",
          "flood_high_hazard_sfha",
          "windstorm_named_windstorm_hurricane",
          "building_ordinance_coverage_a",
          "building_ordinance_coverage_b",
          "building_ordinance_coverage_c",
          "building_ordinance_coverage_d",
          "civil_or_military_authority",
          "ingress_egress",
          "debris_removal",
          "service_interruption",
          "contingent_time_element",
          "evacuation_expense",
          "electronic_data_and_media",
          "expediting_expenses",
          "fines_and_penalties",
          "property_in_the_open",
          "pairs_and_sets",
          "trees_shrubs_and_plants",
          "off_premises_storage",
          "outdoor_property",
          "land_improvements",
          "spoilage_perishable_foods",
          "piers_docks_wharfs_seawalls",
          "property_in_course_of_construction",
          "protection_and_preservation_of_property",
          "professional_fees",
          "animals_held_for_research",
          "research_and_development",
          "fire_brigade_and_extinguishing_expenses",
          "soft_costs",
          "vehicles_licensed_for_highway_use",
          "waterway_access",
          "extra_expense",
          "fine_arts",
          "land_water_contamination_and_cleanup_expense",
          "decontamination_costs",
          "leasehold_interest",
          "loss_adjustment_expenses",
          "personal_property_of_officers_and_employees",
          "employee_tools",
          "transit",
          "accounts_receivable",
          "mold_and_fungus",
          "errors_and_omissions",
          "miscellaneous_unnamed_locations",
          "newly_acquired_automatic_coverage",
          "extended_period_of_indemnity",
          "backup_of_sewers_and_drains_sump_overflow",
          "brands_and_labels",
          "code_upgrade_upgrade_to_green",
          "employee_personal_effects",
          "exhibition_trade_show_property",
          "freeze",
          "leader_property",
          "money_and_securities",
          "off_premises_property_temporary_locations",
          "refrigerated_property_temperature_change",
          "sprinkler_leakage",
          "strikes_riots_and_civil_commotion",
          "valuable_papers_and_records",
          "ordinary_payroll",
          "impounded_water",
          "land_and_water_cleanup_expense",
          "limited_pollution",
          "contractors_equipment",
          "rental_value",
          "royalties",
          "cyber",
          "asbestos",
          "equipment_breakdown",
          "consequential_loss",
          "cancellation_of_bookings",
        ],
      },
      type: "object",
      title: "Manual Limits",
    },
    active_filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Active Filename",
    },
  },
  type: "object",
  required: ["extracted_limits", "manual_limits"],
  title: "LimitAndSublimitInfo",
} as const;

export const $LimitSummary = {
  properties: {
    occurrence: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Occurrence",
    },
    aggregate: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aggregate",
    },
    zone: {
      type: "string",
      title: "Zone",
    },
  },
  type: "object",
  required: ["occurrence", "aggregate", "zone"],
  title: "LimitSummary",
} as const;

export const $LimitSummaryRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "address_ids"],
  title: "LimitSummaryRequest",
} as const;

export const $LimitSummaryResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/LimitSummary",
        },
        propertyNames: {
          enum: ["PWH", "PES", "PFL", "PWB", "PWT", "AOP"],
        },
        type: "object",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "LimitSummaryResponse",
} as const;

export const $ListAdditionalFilesResponse = {
  properties: {
    files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "ListAdditionalFilesResponse",
} as const;

export const $ListBorLettersRequest = {
  properties: {
    active_only: {
      type: "boolean",
      title: "Active Only",
      default: false,
    },
  },
  type: "object",
  title: "ListBorLettersRequest",
} as const;

export const $ListContactsResponse = {
  properties: {
    contacts: {
      items: {
        $ref: "#/components/schemas/ReportContact",
      },
      type: "array",
      title: "Contacts",
    },
  },
  type: "object",
  required: ["contacts"],
  title: "ListContactsResponse",
} as const;

export const $ListPolicyFlyApplicationsResponse = {
  properties: {
    applications: {
      items: {
        $ref: "#/components/schemas/PolicyFlyApplicationRow",
      },
      type: "array",
      title: "Applications",
    },
  },
  type: "object",
  required: ["applications"],
  title: "ListPolicyFlyApplicationsResponse",
} as const;

export const $ListReportActionLogsRequest = {
  properties: {},
  type: "object",
  title: "ListReportActionLogsRequest",
} as const;

export const $ListReportActionLogsResponse = {
  properties: {
    summaries: {
      items: {
        $ref: "#/components/schemas/ReportActionSummaryWithName",
      },
      type: "array",
      title: "Summaries",
    },
  },
  type: "object",
  required: ["summaries"],
  title: "ListReportActionLogsResponse",
} as const;

export const $ListReportJobsRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    statuses: {
      items: {
        $ref: "#/components/schemas/WorkStatus",
      },
      type: "array",
      title: "Statuses",
    },
  },
  type: "object",
  required: ["report_ids", "statuses"],
  title: "ListReportJobsRequest",
} as const;

export const $ListReportJobsResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/ReportJobBatchEntry",
      },
      type: "array",
      title: "Jobs",
    },
  },
  type: "object",
  required: ["jobs"],
  title: "ListReportJobsResponse",
} as const;

export const $ListReportsRequest = {
  properties: {
    lobs: {
      items: {
        type: "string",
        enum: ["property", "builders_risk", "cat", "property_renewal"],
      },
      type: "array",
      title: "Lobs",
    },
  },
  type: "object",
  required: ["lobs"],
  title: "ListReportsRequest",
} as const;

export const $ListReportsResponse = {
  properties: {
    reports: {
      items: {
        $ref: "#/components/schemas/ReportMetadataResponse",
      },
      type: "array",
      title: "Reports",
    },
  },
  type: "object",
  required: ["reports"],
  title: "ListReportsResponse",
} as const;

export const $ListSavedFiltersResponse = {
  properties: {
    filters: {
      items: {
        $ref: "#/components/schemas/SavedFilter",
      },
      type: "array",
      title: "Filters",
    },
  },
  type: "object",
  required: ["filters"],
  title: "ListSavedFiltersResponse",
} as const;

export const $ListTemplatesResponse = {
  properties: {
    templates: {
      items: {
        $ref: "#/components/schemas/Template",
      },
      type: "array",
      title: "Templates",
    },
  },
  type: "object",
  required: ["templates"],
  title: "ListTemplatesResponse",
} as const;

export const $ListUpdatingReportsRequest = {
  properties: {
    since: {
      type: "string",
      format: "date-time",
      title: "Since",
    },
  },
  type: "object",
  required: ["since"],
  title: "ListUpdatingReportsRequest",
} as const;

export const $ListUpdatingReportsResponse = {
  properties: {
    updates: {
      items: {
        $ref: "#/components/schemas/ReportBeingUpdated",
      },
      type: "array",
      title: "Updates",
    },
  },
  type: "object",
  required: ["updates"],
  title: "ListUpdatingReportsResponse",
} as const;

export const $ListUserResponse = {
  properties: {
    current_user: {
      $ref: "#/components/schemas/User",
    },
    all_company_users: {
      items: {
        $ref: "#/components/schemas/User",
      },
      type: "array",
      title: "All Company Users",
    },
  },
  type: "object",
  required: ["current_user", "all_company_users"],
  title: "ListUserResponse",
} as const;

export const $LoadAddressesForMapRequest = {
  properties: {
    lobs: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Lobs",
    },
  },
  type: "object",
  required: ["lobs"],
  title: "LoadAddressesForMapRequest",
} as const;

export const $LoadAddressesForMapResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/SpatialKeyAddress",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "LoadAddressesForMapResponse",
} as const;

export const $LocationAddress = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    street_address: {
      type: "string",
      title: "Street Address",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    lat: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lat",
    },
    long: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Long",
    },
  },
  type: "object",
  required: ["address_id", "street_address", "tiv"],
  title: "LocationAddress",
} as const;

export const $LocationClassification = {
  properties: {
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    wind_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["tier_1", "tier_2"],
        },
        {
          type: "null",
        },
      ],
      title: "Wind Tier",
    },
    wind_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "South Florida",
            "Southwest Florida",
            "Central Florida",
            "Northeast Florida",
            "Panhandle Florida",
            "Georgia / South Carolina",
            "North Carolina",
            "Texas incl. Harris County",
            "Louisiana",
            "Mississippi",
            "Alabama",
            "Mid-Atlantic (VA/MD/DE)",
            "Northeast (NY/NJ/CT/RI/MA/NH/ME)",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Wind Gate",
    },
    eq_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "CA High Hazard",
            "Pacific NW",
            "Intermountain West",
            "New Madrid",
            "Northeast",
            "Other U.S. EQ",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Eq Gate",
    },
  },
  type: "object",
  required: ["state", "county", "wind_tier", "wind_gate", "eq_gate"],
  title: "LocationClassification",
} as const;

export const $LocationClassificationsRequest = {
  properties: {
    locations: {
      items: {
        $ref: "#/components/schemas/LocationKey",
      },
      type: "array",
      maxItems: 10000,
      title: "Locations",
    },
  },
  type: "object",
  required: ["locations"],
  title: "LocationClassificationsRequest",
} as const;

export const $LocationClassificationsResponse = {
  properties: {
    results: {
      items: {
        $ref: "#/components/schemas/LocationClassification",
      },
      type: "array",
      title: "Results",
    },
  },
  type: "object",
  required: ["results"],
  title: "LocationClassificationsResponse",
} as const;

export const $LocationKey = {
  properties: {
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
  },
  type: "object",
  required: ["state", "county"],
  title: "LocationKey",
} as const;

export const $LogEventRequest = {
  properties: {
    event_name: {
      type: "string",
      title: "Event Name",
    },
    event_properties: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
          {
            type: "number",
          },
        ],
      },
      type: "object",
      title: "Event Properties",
    },
  },
  type: "object",
  required: ["event_name", "event_properties"],
  title: "LogEventRequest",
} as const;

export const $LoginResponse = {
  properties: {
    access_token: {
      type: "string",
      title: "Access Token",
    },
    token_type: {
      type: "string",
      title: "Token Type",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    user: {
      $ref: "#/components/schemas/User",
    },
  },
  type: "object",
  required: ["access_token", "token_type", "client_id", "user"],
  title: "LoginResponse",
} as const;

export const $LossControlAnswer = {
  properties: {
    short_answer: {
      type: "string",
      title: "Short Answer",
    },
    long_answer: {
      type: "string",
      title: "Long Answer",
    },
  },
  type: "object",
  required: ["short_answer", "long_answer"],
  title: "LossControlAnswer",
} as const;

export const $LossControlReport = {
  properties: {
    entity_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Entity Name",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    fields: {
      additionalProperties: {
        anyOf: [
          {
            $ref: "#/components/schemas/LossControlAnswer",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Fields",
    },
  },
  type: "object",
  required: ["filename", "fields"],
  title: "LossControlReport",
} as const;

export const $LossRunInfo = {
  properties: {
    loss_runs_by_year: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              $ref: "#/components/schemas/UserGeneratedLossRunByYear",
            },
            {
              $ref: "#/components/schemas/ComputedLossRunByYear",
            },
            {
              $ref: "#/components/schemas/ParsedLossRunByYear",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Loss Runs By Year",
    },
    enabled_by_source: {
      additionalProperties: {
        $ref: "#/components/schemas/SourceDetailInfo",
      },
      type: "object",
      title: "Enabled By Source",
    },
  },
  type: "object",
  required: ["loss_runs_by_year", "enabled_by_source"],
  title: "LossRunInfo",
} as const;

export const $MappingInfo = {
  properties: {
    original_col_name: {
      type: "string",
      title: "Original Col Name",
    },
    confidence: {
      type: "number",
      title: "Confidence",
    },
  },
  type: "object",
  required: ["original_col_name", "confidence"],
  title: "MappingInfo",
} as const;

export const $MarkBorStepRequest = {
  properties: {
    bor_id: {
      type: "string",
      title: "Bor Id",
    },
    step: {
      type: "string",
      enum: [
        "outgoing_broker_notified_at",
        "incoming_broker_notified_at",
        "rescind_letter_received_at",
        "finalized_at",
        "outgoing_broker_resolution_sent_at",
        "incoming_broker_resolution_sent_at",
      ],
      title: "Step",
    },
    timestamp: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["bor_id", "step"],
  title: "MarkBorStepRequest",
} as const;

export const $MatchingReportInfo = {
  properties: {
    report_name: {
      type: "string",
      title: "Report Name",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    matching_addresses: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Matching Addresses",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    matching_tiv: {
      type: "number",
      title: "Matching Tiv",
      default: 0,
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
      default: 0,
    },
  },
  type: "object",
  required: ["report_name", "report_id", "matching_addresses", "created_at_ts"],
  title: "MatchingReportInfo",
} as const;

export const $MatchingReportsByAddresses = {
  properties: {
    matching_report_info: {
      items: {
        $ref: "#/components/schemas/MatchingReportInfo",
      },
      type: "array",
      title: "Matching Report Info",
    },
  },
  type: "object",
  required: ["matching_report_info"],
  title: "MatchingReportsByAddresses",
} as const;

export const $MultipleCompanyNamesFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "multiple_company_names",
      title: "Flag Id",
    },
    company_names: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Company Names",
    },
  },
  type: "object",
  required: ["flag_id", "company_names"],
  title: "MultipleCompanyNamesFlag",
} as const;

export const $NaicsInfo = {
  properties: {
    code_type: {
      type: "string",
      enum: ["sic", "naics"],
      title: "Code Type",
      default: "naics",
    },
    code: {
      type: "string",
      title: "Code",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["code", "description"],
  title: "NaicsInfo",
} as const;

export const $NearmapData = {
  properties: {
    solar_panels: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Solar Panels",
    },
    structural_damage: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Structural Damage",
    },
    ponding: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Ponding",
    },
    staining: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Staining",
    },
    missing_shingles: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Missing Shingles",
    },
    storm_report_count: {
      type: "integer",
      title: "Storm Report Count",
      default: 0,
    },
    hail_event_count: {
      type: "integer",
      title: "Hail Event Count",
      default: 0,
    },
    max_wind_gust_mph: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Wind Gust Mph",
    },
    latest_storm_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Storm Date",
    },
    buildings: {
      items: {
        $ref: "#/components/schemas/BuildingData",
      },
      type: "array",
      title: "Buildings",
      default: [],
    },
  },
  type: "object",
  title: "NearmapData",
  description: `Curated subset of the Betterview Property Profile response.

Construct from a validated Betterview envelope with :meth:\`from_betterview\`.
The model stays a plain round-trippable struct (\`\`model_validate\`\` /
\`\`model_dump\`\`) so it can be persisted and re-read without re-parsing.`,
} as const;

export const $NearmapInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "NearmapInitiateRequest",
} as const;

export const $NearmapInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "NearmapInitiateResponse",
} as const;

export const $NearmapJobHistoryItem = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
    },
    enriched_count: {
      type: "integer",
      title: "Enriched Count",
    },
  },
  type: "object",
  required: [
    "batch_id",
    "status",
    "started_at",
    "finished_at",
    "num_addresses",
    "enriched_count",
  ],
  title: "NearmapJobHistoryItem",
} as const;

export const $NearmapJobHistoryResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/NearmapJobHistoryItem",
      },
      type: "array",
      title: "Jobs",
      default: [],
    },
  },
  type: "object",
  title: "NearmapJobHistoryResponse",
} as const;

export const $OFACHit = {
  properties: {
    sanction_lists: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Sanction Lists",
    },
    entity_description: {
      type: "string",
      title: "Entity Description",
    },
  },
  type: "object",
  required: ["sanction_lists", "entity_description"],
  title: "OFACHit",
} as const;

export const $OFACResult = {
  properties: {
    hits: {
      items: {
        $ref: "#/components/schemas/OFACHit",
      },
      type: "array",
      title: "Hits",
    },
  },
  type: "object",
  required: ["hits"],
  title: "OFACResult",
} as const;

export const $OccupancyData = {
  properties: {
    use_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Use Code",
    },
    standardized_land_use_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Standardized Land Use Code",
    },
    number_of_units: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Units",
    },
  },
  type: "object",
  title: "OccupancyData",
  description: "Occupancy (O) from COPE — how the building is used.",
} as const;

export const $OccupancyMix = {
  properties: {
    occupancy_description: {
      type: "string",
      title: "Occupancy Description",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["occupancy_description", "tiv", "pct_tiv"],
  title: "OccupancyMix",
} as const;

export const $OverrideableListElement_RawAdditionalInterest_Literal__todo___ = {
  properties: {
    original: {
      anyOf: [
        {
          $ref: "#/components/schemas/RawAdditionalInterest",
        },
        {
          type: "null",
        },
      ],
    },
    deleted: {
      type: "boolean",
      title: "Deleted",
    },
    inserted: {
      anyOf: [
        {
          $ref: "#/components/schemas/RawAdditionalInterest",
        },
        {
          type: "null",
        },
      ],
    },
    flags: {
      additionalProperties: {
        type: "string",
        const: "todo",
      },
      type: "object",
      title: "Flags",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
  },
  type: "object",
  required: ["original", "deleted", "inserted", "flags", "overrides"],
  title: "OverrideableListElement[RawAdditionalInterest, Literal['todo']]",
} as const;

export const $ParsedLoss = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    date_of_loss: {
      type: "string",
      title: "Date Of Loss",
    },
    address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Address",
    },
    claim_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Claim Id",
    },
    loss_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    deductible: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    is_cat_event: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Cat Event",
    },
    claim_type: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Claim Type",
    },
    source: {
      type: "string",
      const: "parsed",
      title: "Source",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
    flags: {
      additionalProperties: {
        items: {
          type: "string",
          const: "could_not_parse",
        },
        type: "array",
      },
      type: "object",
      title: "Flags",
    },
    original_values: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Original Values",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "date_of_loss",
    "address",
    "claim_id",
    "loss_id",
    "status",
    "description",
    "ground_up_loss",
    "deductible",
    "net_incurred",
    "is_cat_event",
    "claim_type",
    "source",
    "source_details",
    "overrides",
    "flags",
    "original_values",
  ],
  title: "ParsedLoss",
} as const;

export const $ParsedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    source: {
      type: "string",
      const: "parsed_year",
      title: "Source",
    },
    open_claims: {
      type: "integer",
      title: "Open Claims",
    },
    closed_claims: {
      type: "integer",
      title: "Closed Claims",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    carrier: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Carrier",
    },
    flags: {
      additionalProperties: {
        items: {
          type: "string",
          const: "could_not_parse",
        },
        type: "array",
      },
      type: "object",
      title: "Flags",
    },
    original_values: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Original Values",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "source",
    "open_claims",
    "closed_claims",
    "ground_up_loss",
    "net_incurred",
    "carrier",
    "flags",
    "original_values",
    "overrides",
  ],
  title: "ParsedLossRunByYear",
} as const;

export const $PerilCodePremium = {
  properties: {
    peril_code: {
      type: "string",
      title: "Peril Code",
    },
    aal: {
      type: "number",
      title: "Aal",
    },
    share_aal: {
      type: "number",
      title: "Share Aal",
    },
    multiplier: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiplier",
    },
    multiplier_reason: {
      type: "string",
      title: "Multiplier Reason",
    },
    layer_premium: {
      type: "number",
      title: "Layer Premium",
    },
    share_premium: {
      type: "number",
      title: "Share Premium",
    },
    layer_effective: {
      type: "number",
      title: "Layer Effective",
    },
    share_effective: {
      type: "number",
      title: "Share Effective",
    },
    missing: {
      type: "boolean",
      title: "Missing",
    },
    warnings: {
      additionalProperties: {
        type: "integer",
      },
      type: "object",
      title: "Warnings",
    },
    override_type: {
      anyOf: [
        {
          type: "string",
          enum: ["multiple", "premium"],
        },
        {
          type: "null",
        },
      ],
      title: "Override Type",
    },
    override_multiple: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Override Multiple",
    },
    override_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Override Premium",
    },
  },
  type: "object",
  required: [
    "peril_code",
    "aal",
    "share_aal",
    "multiplier",
    "multiplier_reason",
    "layer_premium",
    "share_premium",
    "layer_effective",
    "share_effective",
    "missing",
    "warnings",
  ],
  title: "PerilCodePremium",
} as const;

export const $PerilMultipleCategories = {
  properties: {
    ns: {
      type: "string",
      enum: ["tri_county", "fl", "gulf_x_fl", "baseline"],
      title: "Ns",
    },
    ns_reason: {
      type: "string",
      title: "Ns Reason",
    },
    eq: {
      type: "string",
      enum: ["eq_ca_a", "eq_ca_b", "ca", "pnw", "baseline"],
      title: "Eq",
    },
    eq_reason: {
      type: "string",
      title: "Eq Reason",
    },
  },
  type: "object",
  required: ["ns", "ns_reason", "eq", "eq_reason"],
  title: "PerilMultipleCategories",
} as const;

export const $PerilScores = {
  properties: {
    hurricane: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hurricane",
    },
    storm_surge: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Storm Surge",
    },
    earthquake: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Earthquake",
    },
    flood: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood",
    },
    wildfire: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wildfire",
    },
    snow_load: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Snow Load",
    },
    ground_snow_load: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Snow Load",
    },
    wind: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind",
    },
    hail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hail",
    },
    tornado: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tornado",
    },
    lightning: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lightning",
    },
  },
  type: "object",
  title: "PerilScores",
  description:
    "Letter grades from the HazardHub risks section for modeled perils.",
} as const;

export const $PerilTypeBreakdown = {
  properties: {
    resolved: {
      $ref: "#/components/schemas/PerilTypePremium",
    },
    by_source: {
      additionalProperties: {
        $ref: "#/components/schemas/PerilTypePremium",
      },
      propertyNames: {
        enum: ["air", "rms", "spatialkat"],
      },
      type: "object",
      title: "By Source",
    },
  },
  type: "object",
  required: ["resolved", "by_source"],
  title: "PerilTypeBreakdown",
  description: `Per-peril-type slice of LayerPremiumBreakdown.

Each peril type carries two views of the same parts:

- \`\`resolved\`\` is the cross-source rollup: data from whichever source
  was picked for this peril type (\`\`PerilTypePremium.source\`\` points at
  that real vendor), with \`\`share_effective\`\` re-distributed via a
  second largest-remainder pass so the per-peril shares across the
  whole layer reconcile to \`\`share_total\`\` exactly. Always present.
- \`\`by_source\`\` is the per-real-source breakdown. Entries are only
  present for sources that have data (or stubs) for this peril type.`,
} as const;

export const $PerilTypePremium = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    source: {
      type: "string",
      enum: ["air", "rms", "spatialkat"],
      title: "Source",
    },
    parts: {
      items: {
        $ref: "#/components/schemas/PerilCodePremium",
      },
      type: "array",
      title: "Parts",
    },
    total_aal: {
      type: "number",
      title: "Total Aal",
      default: 0,
    },
    total_share_aal: {
      type: "number",
      title: "Total Share Aal",
    },
    share_effective: {
      type: "number",
      title: "Share Effective",
    },
    layer_effective: {
      type: "number",
      title: "Layer Effective",
    },
    multiple_effective: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiple Effective",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "source",
    "parts",
    "total_share_aal",
    "share_effective",
    "layer_effective",
    "multiple_effective",
  ],
  title: "PerilTypePremium",
} as const;

export const $PolicyFlyApplication = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
    url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Url",
    },
    request_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Request Id",
    },
  },
  type: "object",
  required: ["layer_id", "suffix"],
  title: "PolicyFlyApplication",
} as const;

export const $PolicyFlyApplicationRow = {
  properties: {
    base_policy_id: {
      type: "string",
      title: "Base Policy Id",
    },
    total_premium: {
      type: "integer",
      title: "Total Premium",
    },
    policy_status: {
      type: "string",
      title: "Policy Status",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    report_metadata: {
      $ref: "#/components/schemas/CommericalReportMetadata",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "lost",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
    layer: {
      anyOf: [
        {
          $ref: "#/components/schemas/LayerSummary",
        },
        {
          type: "null",
        },
      ],
    },
    application_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Application Url",
    },
  },
  type: "object",
  required: [
    "base_policy_id",
    "total_premium",
    "policy_status",
    "report_id",
    "lob",
    "report_metadata",
    "created_at_ts",
    "assignee",
    "status",
    "broker_contact",
    "google_group_email",
    "layer",
    "application_url",
  ],
  title: "PolicyFlyApplicationRow",
} as const;

export const $PolicyFlyInfo = {
  properties: {
    applications: {
      items: {
        $ref: "#/components/schemas/PolicyFlyApplication",
      },
      type: "array",
      title: "Applications",
    },
  },
  type: "object",
  required: ["applications"],
  title: "PolicyFlyInfo",
} as const;

export const $PolicyInfo = {
  properties: {
    selected_policy_form_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Selected Policy Form Name",
    },
    included_perils: {
      items: {
        anyOf: [
          {
            type: "string",
            enum: [
              "aop",
              "earthquake",
              "earth_movement",
              "named_storm",
              "scs",
              "flood",
              "wildfire",
              "equipment_breakdown",
            ],
          },
          {
            type: "string",
            const: "wind_and_hail",
          },
        ],
      },
      type: "array",
      title: "Included Perils",
    },
    peril_sentence_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Peril Sentence Override",
    },
    valuation_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/ValuationInfo",
        },
        {
          type: "null",
        },
      ],
    },
    form_selection: {
      anyOf: [
        {
          type: "string",
          enum: ["ISO", "Co-Participation", "Manuscript"],
        },
        {
          type: "null",
        },
      ],
      title: "Form Selection",
    },
    broker_commission_percentage: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Commission Percentage",
    },
    peril_sources: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
            enum: ["air", "rms", "spatialkat"],
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Peril Sources",
    },
    edited_fields: {
      items: {
        type: "string",
      },
      type: "array",
      uniqueItems: true,
      title: "Edited Fields",
    },
  },
  type: "object",
  required: ["selected_policy_form_name", "included_perils"],
  title: "PolicyInfo",
} as const;

export const $PolicyQuestion = {
  properties: {
    question: {
      type: "string",
      title: "Question",
    },
    short_answer: {
      type: "string",
      title: "Short Answer",
    },
    long_answer: {
      type: "string",
      title: "Long Answer",
    },
    question_id: {
      type: "string",
      title: "Question Id",
    },
    excerpt: {
      type: "string",
      title: "Excerpt",
    },
    confidence: {
      type: "string",
      title: "Confidence",
    },
    page_location: {
      type: "string",
      title: "Page Location",
    },
  },
  type: "object",
  required: [
    "question",
    "short_answer",
    "long_answer",
    "question_id",
    "excerpt",
    "confidence",
    "page_location",
  ],
  title: "PolicyQuestion",
} as const;

export const $PolicyQuestionAndAnswer = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    question: {
      type: "string",
      title: "Question",
    },
    answer: {
      type: "string",
      title: "Answer",
    },
    answer_type: {
      type: "string",
      enum: ["Yes", "No", "N/A"],
      title: "Answer Type",
    },
    excerpt: {
      type: "string",
      title: "Excerpt",
    },
  },
  type: "object",
  required: ["id", "question", "answer", "answer_type", "excerpt"],
  title: "PolicyQuestionAndAnswer",
} as const;

export const $PolicyQuestionsForDocuments = {
  properties: {
    questions_by_file: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionsForFile",
      },
      type: "array",
      title: "Questions By File",
    },
  },
  type: "object",
  required: ["questions_by_file"],
  title: "PolicyQuestionsForDocuments",
} as const;

export const $PolicyQuestionsForFile = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    questions_by_section: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionsForSection",
      },
      type: "array",
      title: "Questions By Section",
    },
  },
  type: "object",
  required: ["filename", "questions_by_section"],
  title: "PolicyQuestionsForFile",
} as const;

export const $PolicyQuestionsForSection = {
  properties: {
    section: {
      type: "string",
      title: "Section",
    },
    questions: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionAndAnswer",
      },
      type: "array",
      title: "Questions",
    },
  },
  type: "object",
  required: ["section", "questions"],
  title: "PolicyQuestionsForSection",
} as const;

export const $PrecomputedMetadata = {
  properties: {
    num_locations: {
      type: "integer",
      title: "Num Locations",
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    unique_location_states: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Unique Location States",
    },
    appetite: {
      anyOf: [
        {
          $ref: "#/components/schemas/Appetite",
        },
        {
          type: "null",
        },
      ],
    },
    matching_reports_by_addresses: {
      anyOf: [
        {
          $ref: "#/components/schemas/MatchingReportsByAddresses",
        },
        {
          type: "null",
        },
      ],
    },
    premium_categories: {
      $ref: "#/components/schemas/PerilMultipleCategories",
    },
  },
  type: "object",
  required: ["num_locations", "total_tiv"],
  title: "PrecomputedMetadata",
} as const;

export const $PremiumError = {
  properties: {
    code: {
      type: "string",
      title: "Code",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["code", "message"],
  title: "PremiumError",
} as const;

export const $ProtectionData = {
  properties: {
    fire_protection_grade: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Protection Grade",
    },
    fire_protection_class: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Protection Class",
    },
    hydrant_score: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hydrant Score",
    },
    drive_distance_to_fire_station_miles: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Drive Distance To Fire Station Miles",
    },
    drive_time_to_fire_station_minutes: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Drive Time To Fire Station Minutes",
    },
    fire_station_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Station Type",
    },
  },
  type: "object",
  title: "ProtectionData",
  description: "Protection (P) from COPE — fire protection characteristics.",
} as const;

export const $QuoteIndicationPreflight = {
  properties: {
    account_name: {
      type: "string",
      title: "Account Name",
    },
    effective_date: {
      type: "string",
      title: "Effective Date",
    },
    expiration_date: {
      type: "string",
      title: "Expiration Date",
    },
    limit_of_liability: {
      type: "string",
      title: "Limit Of Liability",
    },
    total_insured_value: {
      type: "string",
      title: "Total Insured Value",
    },
    deductibles: {
      items: {
        $ref: "#/components/schemas/DeductibleEntry",
      },
      type: "array",
      title: "Deductibles",
    },
    commission: {
      type: "string",
      title: "Commission",
    },
  },
  type: "object",
  required: [
    "account_name",
    "effective_date",
    "expiration_date",
    "limit_of_liability",
    "total_insured_value",
    "deductibles",
    "commission",
  ],
  title: "QuoteIndicationPreflight",
} as const;

export const $QuoteIndicationPreflightRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    effective_perils: {
      items: {
        anyOf: [
          {
            type: "string",
            enum: [
              "aop",
              "earthquake",
              "earth_movement",
              "named_storm",
              "scs",
              "flood",
              "wildfire",
              "equipment_breakdown",
            ],
          },
          {
            type: "string",
            const: "wind_and_hail",
          },
        ],
      },
      type: "array",
      title: "Effective Perils",
    },
    perils_insured: {
      type: "string",
      title: "Perils Insured",
    },
  },
  type: "object",
  required: ["report_id", "layer_id", "effective_perils", "perils_insured"],
  title: "QuoteIndicationPreflightRequest",
  description: `Inputs the frontend computes locally and ships to the backend.

\`effective_perils\` and \`perils_insured\` are derived by the frontend's
\`getEffectiveIncludedPerils\` and \`perilSentenceFromEnabledPerils\` helpers,
which are also used by LayersCard, PolicyFlyModal, and GeneralInput. Keeping
the computation in one place (the frontend) is intentional — we don't
duplicate that logic in Python.`,
} as const;

export const $RMSLocationDetail = {
  properties: {
    locationWsDetail: {
      $ref: "#/components/schemas/RMSLocationWsDetail",
    },
    address: {
      $ref: "#/components/schemas/RmsAddressDetail",
    },
  },
  type: "object",
  title: "RMSLocationDetail",
  description: "Subset of the RMS GET location response we care about.",
} as const;

export const $RMSLocationResult = {
  properties: {
    location_id: {
      type: "string",
      title: "Location Id",
      default: "",
    },
    location_number: {
      type: "string",
      title: "Location Number",
      default: "",
    },
    location_name: {
      type: "string",
      title: "Location Name",
      default: "",
    },
    street_address: {
      type: "string",
      title: "Street Address",
      default: "",
    },
    city: {
      type: "string",
      title: "City",
      default: "",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    aal_rl_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "object",
      title: "Aal Rl By Peril",
      default: {},
    },
    location_detail: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationDetail",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["address_id"],
  title: "RMSLocationResult",
} as const;

export const $RMSLocationWsDetail = {
  properties: {
    distToCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Disttocoast",
    },
    sysDistToCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sysdisttocoast",
    },
    distToCoastCov: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Disttocoastcov",
    },
    distToCoastMatch: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSMatchInfo",
        },
        {
          type: "null",
        },
      ],
    },
    distanceToInnerCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Distancetoinnercoast",
    },
    coastalSegment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Coastalsegment",
    },
    windPool: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Windpool",
    },
  },
  type: "object",
  title: "RMSLocationWsDetail",
  description: "Wind-storm detail from the RMS location detail response.",
} as const;

export const $RMSMatchInfo = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
  },
  type: "object",
  required: ["name"],
  title: "RMSMatchInfo",
  description: "RMS hazard match quality indicator (e.g. distToCoastMatch).",
} as const;

export const $RateComponentsAddressEntry = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    premises_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Premises Number",
    },
    location_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Name",
    },
    street_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street Address",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    sic_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sic Code",
    },
    components: {
      additionalProperties: {
        $ref: "#/components/schemas/RateCoverageComponents",
      },
      propertyNames: {
        enum: ["BGI", "BGII", "SCL"],
      },
      type: "object",
      title: "Components",
    },
  },
  type: "object",
  required: ["address_id", "components"],
  title: "RateComponentsAddressEntry",
} as const;

export const $RateComponentsResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/RateComponentsAddressEntry",
      },
      type: "array",
      title: "Addresses",
    },
    coverage_keys: {
      items: {
        type: "string",
        enum: ["BGI", "BGII", "SCL"],
      },
      type: "array",
      title: "Coverage Keys",
    },
  },
  type: "object",
  required: ["addresses", "coverage_keys"],
  title: "RateComponentsResponse",
} as const;

export const $RateCoverageComponents = {
  properties: {
    base_rate: {
      type: "number",
      title: "Base Rate",
    },
    factors: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Factors",
    },
    building_value: {
      type: "number",
      title: "Building Value",
    },
  },
  type: "object",
  required: ["base_rate", "factors", "building_value"],
  title: "RateCoverageComponents",
  description: `Breakdown of a single building coverage (BGI, BGII, SCL).

base_rate is the ISO Loss Cost in dollars per $100 of building value.
factors maps factor name -> multiplier (both Building Premium factors and
the Adj Building factors). A factor > 1 is a debit, < 1 is a credit.
building_value is the insured building exposure in dollars.
The adjusted premium = base_rate * product(factors) * building_value / 100.`,
} as const;

export const $RatePrecheckResponse = {
  properties: {
    warnings: {
      items: {
        $ref: "#/components/schemas/RatePrecheckWarning",
      },
      type: "array",
      title: "Warnings",
    },
  },
  type: "object",
  required: ["warnings"],
  title: "RatePrecheckResponse",
} as const;

export const $RatePrecheckWarning = {
  properties: {
    summary: {
      type: "string",
      title: "Summary",
    },
    detail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Detail",
    },
    blocking: {
      type: "boolean",
      title: "Blocking",
    },
  },
  type: "object",
  required: ["summary", "detail", "blocking"],
  title: "RatePrecheckWarning",
} as const;

export const $RateSubmissionRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    template_override_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Template Override Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "RateSubmissionRequest",
} as const;

export const $RateSubmissionResponse = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["batch_id"],
  title: "RateSubmissionResponse",
} as const;

export const $RawAdditionalInterest = {
  properties: {
    entity_name: {
      type: "string",
      title: "Entity Name",
    },
    entity_address: {
      type: "string",
      title: "Entity Address",
    },
    form_name: {
      type: "string",
      title: "Form Name",
    },
    linked_address_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Linked Address Id",
    },
  },
  type: "object",
  required: ["entity_name", "entity_address", "form_name", "linked_address_id"],
  title: "RawAdditionalInterest",
} as const;

export const $RawAddress = {
  properties: {
    street_address: {
      type: "string",
      title: "Street Address",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    country: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country",
    },
    country_scheme: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country Scheme",
    },
    country_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country Code",
    },
    year_built: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Built",
    },
    sprinkler: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sprinkler",
    },
    building_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Value",
    },
    bpp_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bpp Value",
    },
    tenant_betterments_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tenant Betterments Value",
    },
    signs_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Signs Value",
    },
    bi_excl_ee_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Excl Ee Value",
    },
    bi_incl_ee_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Incl Ee Value",
    },
    furniture_and_fixtures_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Furniture And Fixtures Value",
    },
    inventory_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Inventory Value",
    },
    contractors_equipment_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Contractors Equipment Value",
    },
    outdoor_property_and_autos_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Outdoor Property And Autos Value",
    },
    number_of_stories: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Stories",
    },
    construction_code_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Code Type",
    },
    construction_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Code",
    },
    construction_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Description",
    },
    occupancy_code_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Code Type",
    },
    occupancy_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Code",
    },
    occupancy_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Description",
    },
    occupancy_description_other: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Description Other",
    },
    sic_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sic Code",
    },
    location_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Name",
    },
    location_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Description",
    },
    lat: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lat",
    },
    long: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Long",
    },
    number_of_buildings: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Buildings",
    },
    square_footage: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Square Footage",
    },
    plan_irregularity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Plan Irregularity",
    },
    soft_story: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Soft Story",
    },
    vertical_irregularity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vertical Irregularity",
    },
    eq_cladding_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eq Cladding Type",
    },
    short_column: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Short Column",
    },
    urm_chimney: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Chimney",
    },
    urm_partition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Partition",
    },
    ornamentation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ornamentation",
    },
    cripple_walls: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cripple Walls",
    },
    frame_bolted_down: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Frame Bolted Down",
    },
    anchoring: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Anchoring",
    },
    urm_retrofit: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Retrofit",
    },
    structural_upgrade: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Structural Upgrade",
    },
    engineered_foundation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Engineered Foundation",
    },
    equipment_eq_bracing: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Eq Bracing",
    },
    eq_construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eq Construction Quality",
    },
    equipment_support_maintenance: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Support Maintenance",
    },
    pounding: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Pounding",
    },
    base_isolation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Base Isolation",
    },
    sprinkler_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sprinkler Type",
    },
    eqsl_susceptibility: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eqsl Susceptibility",
    },
    ws_construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ws Construction Quality",
    },
    roof_geometry: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Geometry",
    },
    roof_anchor: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Anchor",
    },
    roof_equipment_hurricane_bracing: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Equipment Hurricane Bracing",
    },
    commercial_appurtenant_structures: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Commercial Appurtenant Structures",
    },
    roof_covering: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Covering",
    },
    roof_age_or_condition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Age Or Condition",
    },
    ws_cladding_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ws Cladding Type",
    },
    roof_sheathing_attachment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Sheathing Attachment",
    },
    frame_foundation_connection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Frame Foundation Connection",
    },
    residential_appurtenant_structures: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Residential Appurtenant Structures",
    },
    ground_level_equipment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Level Equipment",
    },
    opening_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Opening Protection",
    },
    flashing_and_coping_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flashing And Coping Quality",
    },
    floor_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Floor Type",
    },
    flood_missiles: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Missiles",
    },
    flood_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Protection",
    },
    basement_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Basement Protection",
    },
    vertical_exposure_distribution: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vertical Exposure Distribution",
    },
    bi_preparedness: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Preparedness",
    },
    bi_redundancy: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Redundancy",
    },
    flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Zone",
    },
    wiring_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wiring Year",
    },
    plumbing_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Plumbing Year",
    },
    roofing_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roofing Year",
    },
    heating_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Heating Year",
    },
    fire_alarm_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Alarm Type",
    },
    burglar_alarm_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Burglar Alarm Type",
    },
    premises_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Premises Number",
    },
    building_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Number",
    },
    geocoded_street_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Street Address",
    },
    geocoded_city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded City",
    },
    geocoded_county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded County",
    },
    geocoded_state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded State",
    },
    geocoded_zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Zip",
    },
    geocoded_country: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Country",
    },
  },
  type: "object",
  required: ["street_address", "tiv"],
  title: "RawAddress",
} as const;

export const $RawCompanyInfo = {
  properties: {
    company_name: {
      type: "string",
      title: "Company Name",
    },
    company_description: {
      type: "string",
      title: "Company Description",
    },
    company_industry: {
      type: "string",
      title: "Company Industry",
    },
    effective_date: {
      type: "string",
      title: "Effective Date",
    },
    broker_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Name",
    },
    broker_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Email",
    },
    broker_agent_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Agent Name",
    },
    named_insured: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Named Insured",
    },
    additional_named_insureds: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Named Insureds",
    },
    dba: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Dba",
    },
    entity_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Entity Type",
    },
    expiration_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Expiration Date",
    },
    business_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Business Description",
    },
    years_in_business: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Years In Business",
    },
    company_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Address",
    },
    company_city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company City",
    },
    company_state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company State",
    },
    company_zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Zip",
    },
    target_premium: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Target Premium",
    },
    quote_by_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Quote By Date",
    },
    year_of_incorporation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Of Incorporation",
    },
  },
  type: "object",
  required: [
    "company_name",
    "company_description",
    "company_industry",
    "effective_date",
  ],
  title: "RawCompanyInfo",
} as const;

export const $ReferralText = {
  properties: {
    text: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Text",
    },
  },
  type: "object",
  required: ["text"],
  title: "ReferralText",
} as const;

export const $ReportActionLogEntryResponse = {
  properties: {
    id: {
      type: "integer",
      title: "Id",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "User Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    timestamp: {
      type: "string",
      title: "Timestamp",
    },
    action_type: {
      type: "string",
      enum: [
        "EMAIL_RECEIVED",
        "REPORT_CREATED",
        "EMAIL_ADDED_TO_REPORT",
        "EMAIL_REJECTED_INVALID_SENDER",
        "EMAIL_REJECTED_DUPLICATE",
        "EMAIL_REJECTED_NO_ATTACHMENTS",
        "EMAIL_REJECTED_REPLY_THREAD",
        "UPDATE_REPORT",
        "STATUS_CHANGED",
        "ASSIGNEE_CHANGED",
        "UPDATE_ADDRESSES",
        "INTEGRATION_JOB_ENQUEUED",
        "INTEGRATION_JOB_STARTED",
        "INTEGRATION_JOB_COMPLETED",
        "INTEGRATION_JOB_FAILED",
        "CLEARANCE_EMAIL_SENT",
        "QUOTE_INDICATION_DRAFTED",
        "ATTACHMENT_UPLOADED",
        "ATTACHMENT_DELETED",
        "COMMENT_ADDED",
        "COMMENT_EDITED",
        "COMMENT_DELETED",
        "BOR_CREATED",
        "BOR_FINALIZED",
        "BOR_RESCINDED",
      ],
      title: "Action Type",
    },
    metadata: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Metadata",
    },
  },
  type: "object",
  required: [
    "id",
    "email_message_id",
    "report_id",
    "user_id",
    "client_id",
    "timestamp",
    "action_type",
    "metadata",
  ],
  title: "ReportActionLogEntryResponse",
} as const;

export const $ReportActionSummaryWithName = {
  properties: {
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    company_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Name",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
    email_subject: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Subject",
    },
    sender: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sender",
    },
    latest_action_type: {
      type: "string",
      enum: [
        "EMAIL_RECEIVED",
        "REPORT_CREATED",
        "EMAIL_ADDED_TO_REPORT",
        "EMAIL_REJECTED_INVALID_SENDER",
        "EMAIL_REJECTED_DUPLICATE",
        "EMAIL_REJECTED_NO_ATTACHMENTS",
        "EMAIL_REJECTED_REPLY_THREAD",
        "UPDATE_REPORT",
        "STATUS_CHANGED",
        "ASSIGNEE_CHANGED",
        "UPDATE_ADDRESSES",
        "INTEGRATION_JOB_ENQUEUED",
        "INTEGRATION_JOB_STARTED",
        "INTEGRATION_JOB_COMPLETED",
        "INTEGRATION_JOB_FAILED",
        "CLEARANCE_EMAIL_SENT",
        "QUOTE_INDICATION_DRAFTED",
        "ATTACHMENT_UPLOADED",
        "ATTACHMENT_DELETED",
        "COMMENT_ADDED",
        "COMMENT_EDITED",
        "COMMENT_DELETED",
        "BOR_CREATED",
        "BOR_FINALIZED",
        "BOR_RESCINDED",
      ],
      title: "Latest Action Type",
    },
    latest_timestamp: {
      type: "string",
      title: "Latest Timestamp",
    },
    action_count: {
      type: "integer",
      title: "Action Count",
    },
  },
  type: "object",
  required: ["latest_action_type", "latest_timestamp", "action_count"],
  title: "ReportActionSummaryWithName",
} as const;

export const $ReportBeingUpdated = {
  properties: {
    update_id: {
      type: "string",
      title: "Update Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    running_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Running User Id",
    },
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
    },
    outcome: {
      anyOf: [
        {
          type: "string",
          enum: ["success", "failure"],
        },
        {
          type: "null",
        },
      ],
      title: "Outcome",
    },
    integration_type: {
      type: "string",
      title: "Integration Type",
    },
    policy_fly_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Fly Url",
    },
    error_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Description",
    },
  },
  type: "object",
  required: [
    "update_id",
    "report_id",
    "running_user_id",
    "start_time",
    "outcome",
    "integration_type",
  ],
  title: "ReportBeingUpdated",
} as const;

export const $ReportContact = {
  properties: {
    id: {
      type: "string",
      format: "uuid",
      title: "Id",
    },
    contact_type: {
      $ref: "#/components/schemas/ContactType",
    },
    email: {
      type: "string",
      title: "Email",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  required: [
    "id",
    "contact_type",
    "email",
    "organization_name",
    "full_name",
    "office_phone",
    "cell_phone",
    "role",
  ],
  title: "ReportContact",
} as const;

export const $ReportJobBatchEntry = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    integration_type: {
      type: "string",
      title: "Integration Type",
    },
    outcome: {
      anyOf: [
        {
          type: "string",
          enum: ["success", "failure"],
        },
        {
          type: "null",
        },
      ],
      title: "Outcome",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    env: {
      type: "string",
      title: "Env",
    },
    initiating_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Initiating User Id",
    },
    jobs: {
      items: {
        $ref: "#/components/schemas/ReportJobEntry",
      },
      type: "array",
      title: "Jobs",
    },
    blocked_by_kinds: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Blocked By Kinds",
    },
  },
  type: "object",
  required: [
    "batch_id",
    "report_id",
    "integration_type",
    "outcome",
    "started_at",
    "finished_at",
    "env",
    "initiating_user_id",
    "jobs",
    "blocked_by_kinds",
  ],
  title: "ReportJobBatchEntry",
} as const;

export const $ReportJobEntry = {
  properties: {
    report_integration_id: {
      type: "string",
      title: "Report Integration Id",
    },
    topic: {
      type: "string",
      title: "Topic",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    queue_position: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Queue Position",
    },
    response: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Response",
    },
    icm_progress: {
      anyOf: [
        {
          $ref: "#/components/schemas/IcmJobProgress",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "report_integration_id",
    "topic",
    "status",
    "started_at",
    "queue_position",
    "response",
    "icm_progress",
  ],
  title: "ReportJobEntry",
} as const;

export const $ReportMetadataResponse = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    report_metadata: {
      $ref: "#/components/schemas/CommericalReportMetadata",
    },
    comments: {
      $ref: "#/components/schemas/Comments",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "lost",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "report_metadata",
    "comments",
    "created_at_ts",
    "modified_at_ts",
    "assignee",
    "status",
    "additional_assignees",
    "broker_contact",
    "google_group_email",
  ],
  title: "ReportMetadataResponse",
} as const;

export const $ReportResponse = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    policy_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Number",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    email_subject: {
      type: "string",
      title: "Email Subject",
    },
    report_json: {
      $ref: "#/components/schemas/CommercialReport",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
    review_info: {
      $ref: "#/components/schemas/ReviewInfo",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "lost",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    precomputed_metadata: {
      $ref: "#/components/schemas/PrecomputedMetadata",
    },
    comments: {
      $ref: "#/components/schemas/Comments",
    },
    auto_assignment_style: {
      anyOf: [
        {
          $ref: "#/components/schemas/AutoAssignmentStyle",
        },
        {
          type: "null",
        },
      ],
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
  },
  type: "object",
  required: [
    "report_id",
    "policy_number",
    "lob",
    "email_subject",
    "report_json",
    "created_at_ts",
    "modified_at_ts",
    "review_info",
    "assignee",
    "status",
    "additional_assignees",
    "precomputed_metadata",
    "comments",
    "auto_assignment_style",
    "broker_contact",
    "google_group_email",
  ],
  title: "ReportResponse",
} as const;

export const $RerunComponent = {
  type: "string",
  enum: ["sov", "loss_run", "loss_control", "policy_terms", "policy_questions"],
  title: "RerunComponent",
  description: `A report component that a partial rerun can reprocess in isolation.

The mapping of which attachment types each component reads, and which
attachment changes can be narrowed to which components, lives next to the
parsers in \`\`parse_attachments.py\`\`.`,
} as const;

export const $ResolvedLayerPremium = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
    target: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Target",
    },
    layer_total: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Layer Total",
    },
    share_total: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Share Total",
    },
    has_missing_data: {
      type: "boolean",
      title: "Has Missing Data",
    },
    peril_types: {
      additionalProperties: {
        $ref: "#/components/schemas/ResolvedPerilPremium",
      },
      type: "object",
      title: "Peril Types",
    },
  },
  type: "object",
  required: [
    "layer_id",
    "starting_point",
    "range",
    "participation",
    "target",
    "layer_total",
    "share_total",
    "has_missing_data",
    "peril_types",
  ],
  title: "ResolvedLayerPremium",
} as const;

export const $ResolvedPerilPremium = {
  properties: {
    resolved_layer_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Resolved Layer Aal",
    },
    resolved_share_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Resolved Share Aal",
    },
    layer_premium: {
      type: "number",
      title: "Layer Premium",
    },
    share_premium: {
      type: "number",
      title: "Share Premium",
    },
  },
  type: "object",
  required: [
    "resolved_layer_aal",
    "resolved_share_aal",
    "layer_premium",
    "share_premium",
  ],
  title: "ResolvedPerilPremium",
  description: `Resolved view of one peril type, stripped of vendor data: no source
names, no per-vendor breakdowns. The resolved AAL is deliberately
unattributed — callers can't tell which model produced it.`,
} as const;

export const $ResolvedPremiumsResponse = {
  properties: {
    layers: {
      items: {
        $ref: "#/components/schemas/ResolvedLayerPremium",
      },
      type: "array",
      title: "Layers",
    },
    errors: {
      items: {
        $ref: "#/components/schemas/PremiumError",
      },
      type: "array",
      title: "Errors",
      default: [],
    },
  },
  type: "object",
  required: ["layers"],
  title: "ResolvedPremiumsResponse",
} as const;

export const $ReviewInfo = {
  properties: {
    responses: {
      additionalProperties: {
        $ref: "#/components/schemas/ReviewQuestionResponse",
      },
      type: "object",
      title: "Responses",
      default: {},
    },
  },
  type: "object",
  title: "ReviewInfo",
} as const;

export const $ReviewQuestionResponse = {
  properties: {
    question_id: {
      type: "string",
      title: "Question Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    warning_message: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Warning Message",
    },
    last_updated_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Updated Ts",
    },
    last_updated_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Last Updated User Id",
    },
  },
  type: "object",
  required: ["question_id", "status"],
  title: "ReviewQuestionResponse",
} as const;

export const $RmsAddressDetail = {
  properties: {
    zone1: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone1",
    },
    zone2: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone2",
    },
    zone3: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone3",
    },
  },
  type: "object",
  title: "RmsAddressDetail",
} as const;

export const $RmsEltInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    version: {
      type: "string",
      enum: ["22", "25"],
      title: "Version",
    },
  },
  type: "object",
  required: ["report_id", "version"],
  title: "RmsEltInitiateRequest",
} as const;

export const $RmsEltInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "RmsEltInitiateResponse",
} as const;

export const $RmsInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Layer Ids",
    },
    max_location_override: {
      type: "boolean",
      title: "Max Location Override",
      default: false,
    },
  },
  type: "object",
  required: ["report_id"],
  title: "RmsInitiateRequest",
} as const;

export const $RmsInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "RmsInitiateResponse",
} as const;

export const $SOV = {
  properties: {
    sov_id: {
      type: "string",
      title: "Sov Id",
    },
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
    is_enabled: {
      type: "boolean",
      title: "Is Enabled",
    },
    is_manual: {
      type: "boolean",
      title: "Is Manual",
      default: false,
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    sov_type: {
      anyOf: [
        {
          type: "string",
          enum: ["bound", "submission"],
        },
        {
          type: "null",
        },
      ],
      title: "Sov Type",
    },
    all_document_headers: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "All Document Headers",
    },
    column_mappings: {
      anyOf: [
        {
          additionalProperties: {
            $ref: "#/components/schemas/MappingInfo",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Column Mappings",
    },
    column_overrides: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Column Overrides",
    },
    tiv_totals_match_on_ingest: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Totals Match On Ingest",
    },
    reconciliation_function: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Reconciliation Function",
    },
    tiv_reconciliation_explanation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Reconciliation Explanation",
    },
  },
  type: "object",
  required: ["sov_id", "addresses", "is_enabled", "filename"],
  title: "SOV",
} as const;

export const $SavedFilter = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    url: {
      type: "string",
      title: "Url",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
  },
  type: "object",
  required: ["id", "url", "nickname", "is_default"],
  title: "SavedFilter",
} as const;

export const $SendClearanceEmailRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "lost",
        "bound",
        "issued",
      ],
      title: "Status",
    },
  },
  type: "object",
  required: ["report_id", "status"],
  title: "SendClearanceEmailRequest",
} as const;

export const $SourceDetailInfo = {
  properties: {
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    enabled: {
      type: "boolean",
      title: "Enabled",
    },
  },
  type: "object",
  required: ["source_details", "enabled"],
  title: "SourceDetailInfo",
} as const;

export const $SourceDetails = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    sheet_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sheet Name",
    },
    data_type: {
      type: "string",
      enum: ["claim", "summary"],
      title: "Data Type",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    carrier: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Carrier",
    },
  },
  type: "object",
  required: ["filename", "sheet_name", "data_type", "calc_mode", "carrier"],
  title: "SourceDetails",
} as const;

export const $SourceOverride = {
  properties: {
    multiple: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiple",
    },
    premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Premium",
    },
  },
  type: "object",
  title: "SourceOverride",
  description: `Override for a single peril within a single source.

Exactly one of multiple or premium should be set.
When multiple is set: effective_premium = AAL * multiple.
When premium is set: effective_multiple = premium / AAL.`,
} as const;

export const $SpatialKatInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_ids: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Layer Ids",
    },
    samples: {
      type: "integer",
      title: "Samples",
      default: 10,
    },
  },
  type: "object",
  required: ["report_id"],
  title: "SpatialKatInitiateRequest",
} as const;

export const $SpatialKatInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "SpatialKatInitiateResponse",
} as const;

export const $SpatialKatLocationResult = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    aal_gr: {
      type: "number",
      title: "Aal Gr",
      default: 0,
    },
    aal_net: {
      type: "number",
      title: "Aal Net",
      default: 0,
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
    fema_flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Flood Zone",
    },
    fema_zone_subty: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Zone Subty",
    },
    flood_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Score",
    },
    surge_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Surge Score",
    },
    wind_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Score",
    },
    hail_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Hail Score",
    },
    to_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "To Score",
    },
    slw_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Slw Score",
    },
  },
  type: "object",
  required: ["site_id", "address_id"],
  title: "SpatialKatLocationResult",
  description: "Per-location AAL result stored in integration_data.",
} as const;

export const $SpatialKeyAddress = {
  properties: {
    "Policy Number": {
      type: "string",
      title: "Policy Number",
    },
    "Named Insured": {
      type: "string",
      title: "Named Insured",
    },
    "Effective Date": {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    "Expiration Date": {
      type: "string",
      format: "date",
      title: "Expiration Date",
    },
    "Location #": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location #",
    },
    "Bulding#": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bulding#",
    },
    "Street 1": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street 1",
    },
    "Street 2": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street 2",
    },
    City: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    State: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    Zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    County: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    BLDG: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bldg",
    },
    BPP: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bpp",
    },
    BI_EE: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Ee",
    },
    BI: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bi",
    },
    TIB: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tib",
    },
    SIGNS: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Signs",
    },
    FF: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ff",
    },
    INV: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Inv",
    },
    CE: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ce",
    },
    OPA: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Opa",
    },
    "Total TIV": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    EQPBK: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eqpbk",
    },
    TRIA: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tria",
    },
    LNLawOrdA: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlaworda",
    },
    LNLawOrdBC: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlawordbc",
    },
    LNLawOrd: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlaword",
    },
    Valuation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Valuation",
    },
    Coinsurance: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Coinsurance",
    },
    PTY_WIND_INCL_Y_N: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Pty Wind Incl Y N",
    },
    WIND_DEDUCTIBLE_BASIS: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Basis",
    },
    WIND_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Amount",
    },
    WIND_DEDUCTIBLE_PERCENTAGE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Percentage",
    },
    AOP_DEDUCTIBLE_BASIS: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Basis",
    },
    AOP_DEDUCTIBLE_PERCENTAGE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Percentage",
    },
    AOP_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Amount",
    },
    CP_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cp Deductible Amount",
    },
    CP_DEDUCTIBLE_TYPE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cp Deductible Type",
    },
    "Latitude(SK)": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Latitude(Sk)",
    },
    "Longitude(SK)": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Longitude(Sk)",
    },
    "Geocoding Accuracy": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoding Accuracy",
    },
  },
  type: "object",
  required: [
    "Policy Number",
    "Named Insured",
    "Effective Date",
    "Expiration Date",
  ],
  title: "SpatialKeyAddress",
} as const;

export const $StateSummary = {
  properties: {
    state: {
      type: "string",
      title: "State",
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    construction_mix: {
      items: {
        $ref: "#/components/schemas/ConstructionMix",
      },
      type: "array",
      title: "Construction Mix",
    },
    occupancy_mix: {
      items: {
        $ref: "#/components/schemas/OccupancyMix",
      },
      type: "array",
      title: "Occupancy Mix",
    },
    year_built_distribution: {
      items: {
        $ref: "#/components/schemas/YearBuiltBand",
      },
      type: "array",
      title: "Year Built Distribution",
    },
  },
  type: "object",
  required: [
    "state",
    "total_tiv",
    "construction_mix",
    "occupancy_mix",
    "year_built_distribution",
  ],
  title: "StateSummary",
} as const;

export const $StatusResponse = {
  properties: {
    is_complete: {
      type: "boolean",
      title: "Is Complete",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
  },
  type: "object",
  required: ["is_complete", "status"],
  title: "StatusResponse",
} as const;

export const $Sublimit = {
  properties: {
    sublimit_name: {
      type: "string",
      title: "Sublimit Name",
    },
    sublimit_description: {
      type: "string",
      title: "Sublimit Description",
    },
    document_excerpt: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Document Excerpt",
    },
    manual_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Override",
    },
    is_removed: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Removed",
    },
    classification: {
      anyOf: [
        {
          type: "string",
          enum: ["time_limit", "distance_limit", "waiting_period"],
        },
        {
          type: "null",
        },
      ],
      title: "Classification",
    },
  },
  type: "object",
  required: ["sublimit_name", "sublimit_description", "document_excerpt"],
  title: "Sublimit",
} as const;

export const $SublimitInfo = {
  properties: {
    extracted_sublimits: {
      additionalProperties: {
        items: {
          $ref: "#/components/schemas/Sublimit",
        },
        type: "array",
      },
      type: "object",
      title: "Extracted Sublimits",
    },
    manual_sublimits: {
      items: {
        $ref: "#/components/schemas/Sublimit",
      },
      type: "array",
      title: "Manual Sublimits",
    },
  },
  type: "object",
  required: ["extracted_sublimits", "manual_sublimits"],
  title: "SublimitInfo",
} as const;

export const $SubmissionAnalyticsResponse = {
  properties: {
    reports: {
      items: {
        $ref: "#/components/schemas/SubmissionAnalyticsRow",
      },
      type: "array",
      title: "Reports",
    },
    last_refreshed_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Refreshed At",
    },
  },
  type: "object",
  required: ["reports", "last_refreshed_at"],
  title: "SubmissionAnalyticsResponse",
} as const;

export const $SubmissionAnalyticsRow = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    status: {
      type: "string",
      title: "Status",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    broker_organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Organization Name",
    },
    broker_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Name",
    },
    mode_sic_prefix: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Mode Sic Prefix",
    },
    mode_construction_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Mode Construction Code",
    },
    sum_layer_target_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sum Layer Target Premium",
    },
    sum_policyfly_total_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sum Policyfly Total Premium",
    },
    total_tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    num_locations: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Num Locations",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    first_bound_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "First Bound At",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "status",
    "assignee",
    "broker_organization_name",
    "broker_name",
    "mode_sic_prefix",
    "mode_construction_code",
    "sum_layer_target_premium",
    "sum_policyfly_total_premium",
    "total_tiv",
    "num_locations",
    "created_at",
    "first_bound_at",
  ],
  title: "SubmissionAnalyticsRow",
} as const;

export const $SubmissionStatusCountsResponse = {
  properties: {
    pre_underwriting_review: {
      type: "integer",
      title: "Pre Underwriting Review",
    },
    cleared: {
      type: "integer",
      title: "Cleared",
    },
    in_progress: {
      type: "integer",
      title: "In Progress",
    },
    quoted: {
      type: "integer",
      title: "Quoted",
    },
    bound: {
      type: "integer",
      title: "Bound",
    },
    indicated: {
      type: "integer",
      title: "Indicated",
    },
    quoted_premium: {
      type: "integer",
      title: "Quoted Premium",
    },
    bound_premium: {
      type: "integer",
      title: "Bound Premium",
    },
  },
  type: "object",
  required: [
    "pre_underwriting_review",
    "cleared",
    "in_progress",
    "quoted",
    "bound",
    "indicated",
    "quoted_premium",
    "bound_premium",
  ],
  title: "SubmissionStatusCountsResponse",
} as const;

export const $Template = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    author_id: {
      type: "string",
      title: "Author Id",
    },
    use_case: {
      type: "string",
      title: "Use Case",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    template_pointer: {
      type: "string",
      title: "Template Pointer",
    },
    template_name: {
      type: "string",
      title: "Template Name",
    },
    live: {
      anyOf: [
        {
          type: "boolean",
          const: true,
        },
        {
          type: "null",
        },
      ],
      title: "Live",
    },
  },
  type: "object",
  required: [
    "template_id",
    "client_id",
    "author_id",
    "use_case",
    "created_at_ts",
    "template_pointer",
    "template_name",
    "live",
  ],
  title: "Template",
} as const;

export const $TestPythonFunctionRequest = {
  properties: {
    peril_type: {
      type: "string",
      enum: [
        "aop",
        "earthquake",
        "earth_movement",
        "named_storm",
        "scs",
        "flood",
        "wildfire",
        "equipment_breakdown",
      ],
      title: "Peril Type",
    },
    extracted_filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Extracted Filename",
    },
    function_type: {
      type: "string",
      enum: ["limit", "deductible"],
      title: "Function Type",
    },
  },
  type: "object",
  required: ["peril_type", "function_type"],
  title: "TestPythonFunctionRequest",
} as const;

export const $TestPythonFunctionResponse = {
  properties: {
    num_addresses_run: {
      type: "integer",
      title: "Num Addresses Run",
    },
  },
  type: "object",
  required: ["num_addresses_run"],
  title: "TestPythonFunctionResponse",
} as const;

export const $UnknownCoverageColumnFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "unkonwn_coverage_column",
      title: "Flag Id",
    },
    columns: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Columns",
    },
  },
  type: "object",
  required: ["flag_id", "columns"],
  title: "UnknownCoverageColumnFlag",
} as const;

export const $UnknownInsuranceSubjectFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "non_property_insurance_value_v2",
      title: "Flag Id",
    },
    subjects: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Subjects",
    },
  },
  type: "object",
  required: ["flag_id", "subjects"],
  title: "UnknownInsuranceSubjectFlag",
} as const;

export const $UpdateAddressRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["report_id", "addresses"],
  title: "UpdateAddressRequest",
} as const;

export const $UpdateAddressResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "UpdateAddressResponse",
} as const;

export const $UpdateAsignee = {
  properties: {
    new_assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "New Assignee",
    },
  },
  type: "object",
  required: ["new_assignee"],
  title: "UpdateAsignee",
} as const;

export const $UpdateBrokerContact = {
  properties: {
    new_broker_contact_id: {
      type: "string",
      format: "uuid",
      title: "New Broker Contact Id",
    },
  },
  type: "object",
  required: ["new_broker_contact_id"],
  title: "UpdateBrokerContact",
} as const;

export const $UpdateContactRequest = {
  properties: {
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  title: "UpdateContactRequest",
} as const;

export const $UpdateContactResponse = {
  properties: {
    contact: {
      $ref: "#/components/schemas/ReportContact",
    },
  },
  type: "object",
  required: ["contact"],
  title: "UpdateContactResponse",
} as const;

export const $UpdateGoogleGroup = {
  properties: {
    new_google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "New Google Group Email",
    },
  },
  type: "object",
  required: ["new_google_group_email"],
  title: "UpdateGoogleGroup",
} as const;

export const $UpdateReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    update_assignee: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateAsignee",
        },
        {
          type: "null",
        },
      ],
    },
    update_status: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateStatus",
        },
        {
          type: "null",
        },
      ],
    },
    update_additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_sovs: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/SOV",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Sovs",
    },
    update_loss_runs_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LossRunInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_review_question_response: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReviewQuestionResponse",
        },
        {
          type: "null",
        },
      ],
    },
    update_company_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/CompanyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_attachment_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AttachmentInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_referral_text: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReferralText",
        },
        {
          type: "null",
        },
      ],
    },
    rerun_report: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Rerun Report",
    },
    rerun_components: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/RerunComponent",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Rerun Components",
    },
    update_broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateBrokerContact",
        },
        {
          type: "null",
        },
      ],
    },
    update_limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LimitAndSublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_policy_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/SublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_deductible_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedDeductibleInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_advanced_limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedLimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_layer_info: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/Layer",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Layer Info",
    },
    update_google_group_email: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateGoogleGroup",
        },
        {
          type: "null",
        },
      ],
    },
    update_submission_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Submission Recipients",
    },
  },
  type: "object",
  required: [
    "report_id",
    "update_assignee",
    "update_status",
    "update_additional_assignees",
    "update_sovs",
    "update_loss_runs_info",
    "update_review_question_response",
    "update_company_info",
    "update_attachment_info",
    "update_referral_text",
    "rerun_report",
    "rerun_components",
    "update_broker_contact",
    "update_limit_info",
    "update_policy_info",
    "update_sublimit_info",
    "update_deductible_info",
    "update_advanced_limit_info",
    "update_layer_info",
    "update_google_group_email",
    "update_submission_recipients",
  ],
  title: "UpdateReportRequest",
} as const;

export const $UpdateReportResponse = {
  properties: {
    use_old_sovs: {
      type: "boolean",
      title: "Use Old Sovs",
    },
    report: {
      $ref: "#/components/schemas/ReportResponse",
    },
  },
  type: "object",
  required: ["use_old_sovs", "report"],
  title: "UpdateReportResponse",
} as const;

export const $UpdateSavedFilterRequest = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
  },
  type: "object",
  required: ["id", "is_default", "nickname"],
  title: "UpdateSavedFilterRequest",
} as const;

export const $UpdateStatus = {
  properties: {
    new_status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "lost",
        "bound",
        "issued",
      ],
      title: "New Status",
    },
  },
  type: "object",
  required: ["new_status"],
  title: "UpdateStatus",
} as const;

export const $UpdateTemplate = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
    live: {
      type: "boolean",
      title: "Live",
    },
  },
  type: "object",
  required: ["template_id", "live"],
  title: "UpdateTemplate",
} as const;

export const $UploadAdditionalFilesResponse = {
  properties: {
    files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "UploadAdditionalFilesResponse",
} as const;

export const $UploadEmailThreadResponse = {
  properties: {
    was_new: {
      type: "boolean",
      title: "Was New",
    },
    eml_count: {
      type: "integer",
      title: "Eml Count",
    },
    pf_pushed: {
      type: "integer",
      title: "Pf Pushed",
    },
  },
  type: "object",
  required: ["was_new", "eml_count", "pf_pushed"],
  title: "UploadEmailThreadResponse",
} as const;

export const $User = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    email: {
      type: "string",
      title: "Email",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    lobs: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Lobs",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    profile_image_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Profile Image Url",
    },
    scopes: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Scopes",
    },
    is_client_admin: {
      type: "boolean",
      title: "Is Client Admin",
      default: false,
    },
  },
  type: "object",
  required: ["id", "email", "client_id", "lobs", "scopes"],
  title: "User",
} as const;

export const $UserGeneratedLoss = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    date_of_loss: {
      type: "string",
      title: "Date Of Loss",
    },
    address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Address",
    },
    claim_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Claim Id",
    },
    loss_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    deductible: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    is_cat_event: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Cat Event",
    },
    claim_type: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Claim Type",
    },
    source: {
      type: "string",
      const: "user_generated",
      title: "Source",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "date_of_loss",
    "address",
    "claim_id",
    "loss_id",
    "status",
    "description",
    "ground_up_loss",
    "deductible",
    "net_incurred",
    "is_cat_event",
    "claim_type",
    "source",
    "source_details",
  ],
  title: "UserGeneratedLoss",
} as const;

export const $UserGeneratedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    open_claims: {
      type: "integer",
      title: "Open Claims",
    },
    closed_claims: {
      type: "integer",
      title: "Closed Claims",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    source: {
      type: "string",
      const: "user_generated",
      title: "Source",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "open_claims",
    "closed_claims",
    "ground_up_loss",
    "net_incurred",
    "source",
  ],
  title: "UserGeneratedLossRunByYear",
} as const;

export const $ValidationError = {
  properties: {
    loc: {
      items: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
        ],
      },
      type: "array",
      title: "Location",
    },
    msg: {
      type: "string",
      title: "Message",
    },
    type: {
      type: "string",
      title: "Error Type",
    },
  },
  type: "object",
  required: ["loc", "msg", "type"],
  title: "ValidationError",
} as const;

export const $ValuationInfo = {
  properties: {
    physical_valuation_type_1: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Physical Valuation Type 1",
    },
    physical_valuation_type_2: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Physical Valuation Type 2",
    },
    bi_valuation_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Valuation Type",
    },
    equipment_valuation_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Valuation Type",
    },
  },
  type: "object",
  required: [
    "physical_valuation_type_1",
    "physical_valuation_type_2",
    "bi_valuation_type",
    "equipment_valuation_type",
  ],
  title: "ValuationInfo",
} as const;

export const $VendorPrecheck = {
  properties: {
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    blocked: {
      type: "boolean",
      title: "Blocked",
    },
    run_perils: {
      items: {
        type: "string",
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "array",
      title: "Run Perils",
    },
    skipped_perils: {
      items: {
        type: "string",
        enum: ["PWH", "PSH", "PES", "PFL", "PWB", "PWW", "PWT"],
      },
      type: "array",
      title: "Skipped Perils",
    },
  },
  type: "object",
  required: ["warnings", "blocked", "run_perils", "skipped_perils"],
  title: "VendorPrecheck",
} as const;

export const $WorkStatus = {
  type: "string",
  enum: ["pending", "in_progress", "done", "failed", "cancelled"],
  title: "WorkStatus",
  description: "Status of a queued job.",
} as const;

export const $YearBuiltBand = {
  properties: {
    band: {
      type: "string",
      title: "Band",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["band", "tiv", "pct_tiv"],
  title: "YearBuiltBand",
} as const;

export const $YearIncorporatedDerivedFromSearch = {
  properties: {
    flag_id: {
      type: "string",
      const: "year_incorporated_derived_from_search",
      title: "Flag Id",
    },
    source: {
      type: "string",
      title: "Source",
    },
  },
  type: "object",
  required: ["flag_id", "source"],
  title: "YearIncorporatedDerivedFromSearch",
} as const;
